var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// eslint-disable-next-line @typescript-eslint/triple-slash-reference
///<reference path='../ai-assist-base/ai-assist-base-model.d.ts'/>
import { EventHandler, Property, NotifyPropertyChanges, Collection, Event, remove, L10n, SanitizeHtmlHelper, isNullOrUndefined } from '@syncfusion/ej2-base';
import { ChildProperty, getUniqueID, isNullOrUndefined as isNOU, Complex, removeClass, addClass } from '@syncfusion/ej2-base';
import { Toolbar, FieldSettings } from '@syncfusion/ej2-navigations';
import { Mention } from '@syncfusion/ej2-dropdowns';
import { ToolbarSettings, ToolbarItem } from '../interactive-chat-base/interactive-chat-base';
import { Uploader, SpeechToText } from '@syncfusion/ej2-inputs';
import { MarkdownConverter } from '@syncfusion/ej2-markdown-converter';
import { Fab } from '@syncfusion/ej2-buttons';
import { AIAssistBase, SpeechToTextSettings } from '../ai-assist-base/ai-assist-base';
import { createSpinner, hideSpinner, showSpinner, Tooltip } from '@syncfusion/ej2-popups';
var ASSISTHEADER = 'e-aiassist-header-text e-assist-view-header';
var TELEMETRY_TOOLBAR_ITEM_CSS_CLASS = 'e-assist-telemetry-item';
var TelemetrySettings = /** @class */ (function (_super) {
    __extends(TelemetrySettings, _super);
    function TelemetrySettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Property(false)
    ], TelemetrySettings.prototype, "enable", void 0);
    __decorate([
        Property([])
    ], TelemetrySettings.prototype, "metrics", void 0);
    __decorate([
        Event()
    ], TelemetrySettings.prototype, "beforeReport", void 0);
    return TelemetrySettings;
}(ChildProperty));
export { TelemetrySettings };
/**
 * The prompts property maps the list of the prompts and binds the data to the suggestions.
 */
var Prompt = /** @class */ (function (_super) {
    __extends(Prompt, _super);
    function Prompt() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Property(null)
    ], Prompt.prototype, "prompt", void 0);
    __decorate([
        Property('')
    ], Prompt.prototype, "response", void 0);
    __decorate([
        Property(null)
    ], Prompt.prototype, "isResponseHelpful", void 0);
    __decorate([
        Property(null)
    ], Prompt.prototype, "attachedFiles", void 0);
    __decorate([
        Property(null)
    ], Prompt.prototype, "regeneratedResponses", void 0);
    __decorate([
        Property(null)
    ], Prompt.prototype, "blocks", void 0);
    __decorate([
        Property(null)
    ], Prompt.prototype, "mentions", void 0);
    return Prompt;
}(ChildProperty));
export { Prompt };
/**
 * Specifies the type of assist view.
 */
export var AssistViewType;
(function (AssistViewType) {
    /**
     * Represents the default assist view type.
     */
    AssistViewType["Assist"] = "Assist";
    /**
     * Represents a custom assist view type.
     */
    AssistViewType["Custom"] = "Custom";
})(AssistViewType || (AssistViewType = {}));
/**
 * The assistView property maps the customized AiAssistView.
 */
var AssistView = /** @class */ (function (_super) {
    __extends(AssistView, _super);
    function AssistView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Property('Assist')
    ], AssistView.prototype, "type", void 0);
    __decorate([
        Property('')
    ], AssistView.prototype, "name", void 0);
    __decorate([
        Property()
    ], AssistView.prototype, "iconCss", void 0);
    __decorate([
        Property()
    ], AssistView.prototype, "viewTemplate", void 0);
    return AssistView;
}(ChildProperty));
export { AssistView };
/**
 * Configuration settings for rendering Text-to-Speech in the AssistView.
 * This property holds the settings required to control speech synthesis behavior.
 *
 */
var TextToSpeechSettings = /** @class */ (function (_super) {
    __extends(TextToSpeechSettings, _super);
    function TextToSpeechSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Property('en-US')
    ], TextToSpeechSettings.prototype, "language", void 0);
    __decorate([
        Property(1)
    ], TextToSpeechSettings.prototype, "speechPitch", void 0);
    __decorate([
        Property(1)
    ], TextToSpeechSettings.prototype, "speechRate", void 0);
    __decorate([
        Property('')
    ], TextToSpeechSettings.prototype, "inputText", void 0);
    __decorate([
        Property(null)
    ], TextToSpeechSettings.prototype, "voice", void 0);
    __decorate([
        Property(1)
    ], TextToSpeechSettings.prototype, "volume", void 0);
    return TextToSpeechSettings;
}(ChildProperty));
export { TextToSpeechSettings };
/**
 * Represents settings for managing file attachments in the AI Assist View.
 * Includes configuration for URLs, file types, and size limitations.
 */
var AttachmentSettings = /** @class */ (function (_super) {
    __extends(AttachmentSettings, _super);
    function AttachmentSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Property('')
    ], AttachmentSettings.prototype, "saveUrl", void 0);
    __decorate([
        Property('')
    ], AttachmentSettings.prototype, "removeUrl", void 0);
    __decorate([
        Property('')
    ], AttachmentSettings.prototype, "allowedFileTypes", void 0);
    __decorate([
        Property(2000000)
    ], AttachmentSettings.prototype, "maxFileSize", void 0);
    __decorate([
        Property(10)
    ], AttachmentSettings.prototype, "maximumCount", void 0);
    __decorate([
        Property('')
    ], AttachmentSettings.prototype, "attachmentTemplate", void 0);
    __decorate([
        Event()
    ], AttachmentSettings.prototype, "attachmentClick", void 0);
    return AttachmentSettings;
}(ChildProperty));
export { AttachmentSettings };
/**
 * The promptToolbarSettings property maps the list of the promptToolbarSettings and binds the data to the prompt.
 */
var PromptToolbarSettings = /** @class */ (function (_super) {
    __extends(PromptToolbarSettings, _super);
    function PromptToolbarSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Property('100%')
    ], PromptToolbarSettings.prototype, "width", void 0);
    __decorate([
        Collection([], ToolbarItem)
    ], PromptToolbarSettings.prototype, "items", void 0);
    __decorate([
        Event()
    ], PromptToolbarSettings.prototype, "itemClicked", void 0);
    return PromptToolbarSettings;
}(ChildProperty));
export { PromptToolbarSettings };
/**
 * The responseToolbarSettings property maps the list of the responseToolbarSettings and binds the data to the output items.
 */
var ResponseToolbarSettings = /** @class */ (function (_super) {
    __extends(ResponseToolbarSettings, _super);
    function ResponseToolbarSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Property('100%')
    ], ResponseToolbarSettings.prototype, "width", void 0);
    __decorate([
        Collection([], ToolbarItem)
    ], ResponseToolbarSettings.prototype, "items", void 0);
    __decorate([
        Event()
    ], ResponseToolbarSettings.prototype, "itemClicked", void 0);
    return ResponseToolbarSettings;
}(ChildProperty));
export { ResponseToolbarSettings };
/**
 * Represents a toolbar item model in the AIAssistview component.
 */
var FooterToolbarSettings = /** @class */ (function (_super) {
    __extends(FooterToolbarSettings, _super);
    function FooterToolbarSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Property('Inline')
    ], FooterToolbarSettings.prototype, "toolbarPosition", void 0);
    __decorate([
        Collection([], ToolbarItem)
    ], FooterToolbarSettings.prototype, "items", void 0);
    __decorate([
        Event()
    ], FooterToolbarSettings.prototype, "itemClick", void 0);
    return FooterToolbarSettings;
}(ChildProperty));
export { FooterToolbarSettings };
/**
 * Configuration settings for rendering mention in the AssistView.
 * Specifies the data source, filtering options, popup settings, and templates for mention interactions.
 */
var MentionSettings = /** @class */ (function (_super) {
    __extends(MentionSettings, _super);
    function MentionSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Property('')
    ], MentionSettings.prototype, "mentionChar", void 0);
    __decorate([
        Property([])
    ], MentionSettings.prototype, "dataSource", void 0);
    __decorate([
        Complex({ text: 'text', value: 'id' }, FieldSettings)
    ], MentionSettings.prototype, "fields", void 0);
    __decorate([
        Property(null)
    ], MentionSettings.prototype, "query", void 0);
    __decorate([
        Property('Contains')
    ], MentionSettings.prototype, "filterType", void 0);
    __decorate([
        Property(false)
    ], MentionSettings.prototype, "highlight", void 0);
    __decorate([
        Property(true)
    ], MentionSettings.prototype, "showMentionChar", void 0);
    __decorate([
        Property('auto')
    ], MentionSettings.prototype, "popupWidth", void 0);
    __decorate([
        Property('300px')
    ], MentionSettings.prototype, "popupHeight", void 0);
    __decorate([
        Property('')
    ], MentionSettings.prototype, "displayTemplate", void 0);
    __decorate([
        Property('')
    ], MentionSettings.prototype, "itemTemplate", void 0);
    __decorate([
        Property('No records found')
    ], MentionSettings.prototype, "noRecordsTemplate", void 0);
    return MentionSettings;
}(ChildProperty));
export { MentionSettings };
/**
 * The `AIAssistView` component is designed to enhance user interaction by integrating AI driven assistance features.
 * It provides a seamless interface for incorporating suggestions & AI responses.
 *
 * ```html
 *  <div id='defaultAIAssistView'></div>
 * ```
 * ```typescript
 *  let aiAssistObj: AIAssistView = new AIAssistView();
 *  aiAssistObj.appendTo('#defaultAIAssistView');
 * ```
 */
/**
 * Main AI AssistView component.
 * Renders prompts, responses, tools, telemetry, and footer interactions.
 */
var AIAssistView = /** @class */ (function (_super) {
    __extends(AIAssistView, _super);
    /**
     * Constructor for creating the component
     *
     * @param {AIAssistViewModel} options - Specifies the AIAssistViewModel model.
     * @param {string | HTMLElement} element - Specifies the element to render as component.
     * @private
     */
    function AIAssistView(options, element) {
        var _this = _super.call(this, options, element) || this;
        _this.toolbarItems = [];
        _this.displayContents = [];
        _this.preTagElements = [];
        _this.uploadedFiles = [];
        _this.isAttachmentRemovalCancelled = false;
        _this.sendToolbarItem = null;
        _this.clearToolbarItem = null;
        _this.attachmentToolbarItem = null;
        _this.speechToTextToolbarItem = null;
        _this.latestResponseMinHeight = null;
        _this.currentUtterance = null;
        _this.mentionModels = [];
        _this.regeneratedResponses = new Map();
        _this.regeneratedBlocks = new Map();
        _this.currentRegeneratedIndex = new Map();
        _this.originalResponses = new Map();
        _this.originalBlocks = new Map();
        _this.isRegenerating = false;
        _this.regeneratingPromptIndex = -1;
        _this.blockIndex = 0;
        _this.lastRenderedBlockCount = 0;
        _this.registeredTools = new Map();
        _this.selectedMentions = [];
        _this.mentionCounter = 0;
        /**
         * Telemetry reports keyed by prompt index.
         * Powers the per-response toolbar tooltip and is cleared during destroy().
         */
        _this.telemetryReportsByPrompt = new Map();
        /**
         * Syncfusion `Tooltip` instances keyed by prompt index.
         * Lets each telemetry button update on hover without losing focus or state.
         */
        _this.telemetryTooltipsByPrompt = new Map();
        return _this;
    }
    /**
     * Enhanced setup: Enforce viewport on .e-content + dynamic min-height on latest .e-output-container.
     * Preserves structure; only inline styles on existing elements. Scrolls to prompt top.
     * Also applies during loading by sizing the skeleton container when the final response item
     * isn't rendered yet.
     *
     * @private
     * @returns {void}
     */
    AIAssistView.prototype.setupViewportFilling = function () {
        if (!this.contentWrapper || this.prompts.length === 0) {
            return;
        }
        var lastIndex = this.prompts.length - 1;
        var allResponseItems = Array.from(this.contentWrapper.querySelectorAll('.e-output-container[id^="e-response-item_"]'));
        // Set auto for all previous .e-output-container (as in example)
        for (var i = 0; i < allResponseItems.length; i++) {
            var index = parseInt(allResponseItems[i].id.split('_')[1], 10);
            if (index < lastIndex) {
                allResponseItems[i].style.minHeight = 'auto';
                var footerEle = allResponseItems[i].querySelector('.e-content-footer');
                if (footerEle) {
                    footerEle.classList.remove('e-assist-toolbar-active');
                }
            }
        }
        // Compute dynamic min-height based on viewport and fixed chrome (header/footer/paddings)
        var contentWrapperHeight = this.contentWrapper.clientHeight;
        var promptEle = this.contentWrapper.querySelector("#e-prompt-item_" + lastIndex);
        var promptHeight = promptEle ? promptEle.offsetHeight : 0;
        // Get the actual height of uploaded files if they exist
        var promptFilesEle = promptEle ? promptEle.querySelector('.e-prompt-uploaded-files') : null;
        var promptFilesHeight = promptFilesEle ? promptFilesEle.offsetHeight : 0;
        // Get the actual height of prompt toolbar if it exists
        var promptToolbarEle = promptEle ? promptEle.querySelector('.e-prompt-toolbar') : null;
        var promptToolbarHeight = promptToolbarEle ? promptToolbarEle.offsetHeight : 0;
        // Get the actual height of response toolbar if it exists
        var lastResponseEle = this.contentWrapper.querySelector("#e-response-item_" + lastIndex);
        var responseToolbarEle = lastResponseEle ? lastResponseEle.querySelector('.e-response-toolbar') : null;
        var responseToolbarHeight = responseToolbarEle ? responseToolbarEle.offsetHeight : 0;
        // Check if suggestions are visible - if so, reserve space for them
        var suggestionsHeight = (this.suggestionsElement && !this.suggestionsElement.hidden) ?
            this.suggestionsElement.offsetHeight : 0;
        var scrollToBottomBtnHeight = 0;
        if (this.downArrowIcon.element) {
            scrollToBottomBtnHeight = this.downArrowIcon.element.offsetHeight;
        }
        // Calculate minHeight to fill the content wrapper viewport completely
        var dynamicMinHeight = Math.max(160, contentWrapperHeight - promptHeight - promptFilesHeight - promptToolbarHeight -
            responseToolbarHeight - suggestionsHeight - scrollToBottomBtnHeight);
        this.latestResponseMinHeight = dynamicMinHeight;
        // Apply to the actual latest response container if available; otherwise apply to loading skeleton
        if (lastResponseEle) {
            lastResponseEle.style.minHeight = dynamicMinHeight + "px";
        }
        else if (this.skeletonContainer) {
            // Ensure the loader occupies the viewport so previous chats don't remain visible while loading
            this.skeletonContainer.style.minHeight = dynamicMinHeight + "px";
        }
    };
    AIAssistView.prototype.renderContentElement = function () {
        if (this.enableScrollToBottom) {
            var scrollDownButton = this.createElement('button', { id: this.element.id + "-scrollDownButton", className: 'e-scroll-down-btn' });
            this.downArrowIcon = new Fab({
                iconCss: 'e-icons e-assist-scroll-down',
                position: 'BottomCenter',
                target: this.outputElement.parentElement,
                isPrimary: false,
                visible: false
            });
            this.downArrowIcon.appendTo(scrollDownButton);
        }
    };
    AIAssistView.prototype.handleScroll = function () {
        var atBottom = this.checkScrollAtBottom(this.contentWrapper, 50);
        this.toggleScrollIcon(atBottom);
    };
    // Toggle button visibility (show if not at bottom and enableScrollToBottom=true)
    AIAssistView.prototype.toggleScrollIcon = function (atBottom) {
        if (this.isResponseRequested || !this.enableScrollToBottom || !this.downArrowIcon) {
            return;
        }
        this.downArrowIcon.visible = !atBottom;
        this.downArrowIcon.dataBind();
    };
    // Click handler to scroll to bottom
    AIAssistView.prototype.scrollBtnClick = function () {
        if (this.enableScrollToBottom) {
            this.scrollToBottom();
        }
    };
    AIAssistView.prototype.hasSkeletonEle = function () {
        return this.skeletonContainer && this.outputElement.contains(this.skeletonContainer);
    };
    /**
     * Initialize the event handler
     *
     * @private
     * @returns {void}
     */
    AIAssistView.prototype.preRender = function () {
        if (!this.element.id) {
            this.element.id = getUniqueID('e-' + this.getModuleName());
        }
    };
    AIAssistView.prototype.getDirective = function () {
        return 'EJS-AIASSISTVIEW';
    };
    /**
     * To get component name.
     *
     * @returns {string} - It returns the current module name.
     * @private
     */
    AIAssistView.prototype.getModuleName = function () {
        return 'aiassistview';
    };
    /**
     * Get the properties to be maintained in the persisted state.
     *
     * @private
     * @returns {string} - It returns the persisted data.
     */
    AIAssistView.prototype.getPersistData = function () {
        return this.addOnPersist([]);
    };
    AIAssistView.prototype.render = function () {
        this.initializeLocale();
        this.renderPromptView();
    };
    AIAssistView.prototype.renderPromptView = function () {
        this.setDimension(this.element, this.width, this.height);
        this.renderViews();
        this.renderToolbar();
        this.updateFooterElementClass();
        this.wireEvents();
    };
    AIAssistView.prototype.renderToolbar = function () {
        this.updateHeaderToolbar();
        if (this.assistViewTemplateIndex < 0) {
            this.displayContents.unshift(this.contentWrapper);
        }
        else {
            this.displayContents.unshift(this.assistCustomSection);
        }
        this.previousElement = this.displayContents[this.activeView];
        this.renderHeaderToolbar();
        this.viewWrapper = this.element.querySelector('.e-view-content');
        this.updateActiveView();
        this.addCssClass(this.element, this.cssClass);
        this.updateHeader(this.showHeader, this.toolbarHeader, this.viewWrapper);
        this.aiAssistViewRendered = true;
        this.addRtlClass(this.element, this.enableRtl);
    };
    AIAssistView.prototype.renderViews = function () {
        this.assistViewTemplateIndex = -1;
        this.aiAssistViewRendered = false;
        this.isAssistView = false;
        this.isOutputRenderingStop = false;
        this.isResponseRequested = false;
        this.renderViewSections(this.element, 'e-view-header', 'e-view-content');
        var isAssistViewAssigned = false;
        var assistView;
        var customViewTemplate;
        var customViewCount = 1;
        if (this.views.length > 0) {
            for (var index = 0; index < this.views.length; index++) {
                if (this.views[parseInt(index.toString(), 10)].type.toLocaleLowerCase() === 'assist' && !isAssistViewAssigned) {
                    assistView = {
                        text: this.views[parseInt(index.toString(), 10)].name || 'AI Assist',
                        prefixIcon: this.views[parseInt(index.toString(), 10)].iconCss || 'e-icons e-assistview-icon',
                        cssClass: ASSISTHEADER,
                        htmlAttributes: { 'data-index': this.element.id + '_view_0' }
                    };
                    this.toolbarItems.unshift(assistView);
                    if (this.views[parseInt(index.toString(), 10)].viewTemplate) {
                        this.assistViewTemplateIndex = index;
                    }
                    isAssistViewAssigned = true;
                    this.isAssistView = true;
                }
                else if (this.views[parseInt(index.toString(), 10)].type.toLocaleLowerCase() === 'custom') {
                    customViewTemplate = this.createElement('div', { className: 'e-customview-content-section-' + customViewCount + ' e-custom-view' });
                    this.getContextObject('customViewTemplate', customViewTemplate, -1, index);
                    this.displayContents.push(customViewTemplate);
                    this.toolbarItems.push({
                        text: this.views[parseInt(index.toString(), 10)].name || '',
                        prefixIcon: this.views[parseInt(index.toString(), 10)].iconCss || '',
                        cssClass: 'e-aiassist-header-text e-custom-view-header',
                        htmlAttributes: { 'data-index': this.element.id + '_view_' + customViewCount.toString() }
                    });
                    customViewCount++;
                }
            }
        }
        if (this.views.length === 0 || !isAssistViewAssigned) {
            assistView = {
                text: 'AI Assist',
                prefixIcon: 'e-icons e-assistview-icon',
                cssClass: ASSISTHEADER,
                htmlAttributes: { 'data-index': this.element.id + '_view_0' }
            };
            this.toolbarItems.unshift(assistView);
            isAssistViewAssigned = true;
        }
        if (this.assistViewTemplateIndex >= 0 && this.views[this.assistViewTemplateIndex].viewTemplate) {
            this.assistCustomSection = this.createElement('div', { attrs: { class: 'e-assistview-content-section', 'data-index': this.element.id + '_view_0' } });
            this.getContextObject('assistViewTemplate', this.assistCustomSection, -1, this.assistViewTemplateIndex);
        }
        else {
            this.renderDefaultView();
        }
    };
    AIAssistView.prototype.renderHeaderToolbar = function () {
        var _this = this;
        this.toolbar = new Toolbar({
            items: this.toolbarItems,
            height: '100%',
            enableRtl: this.enableRtl,
            clicked: function (args) {
                var eventItemArgs = {
                    type: args.item.type,
                    text: args.item.text,
                    iconCss: args.item.prefixIcon,
                    cssClass: args.item.cssClass,
                    tooltip: args.item.tooltipText,
                    template: args.item.template,
                    disabled: args.item.disabled,
                    visible: args.item.visible,
                    align: args.item.align,
                    tabIndex: args.item.tabIndex
                };
                var eventArgs = {
                    item: eventItemArgs,
                    event: args.originalEvent,
                    cancel: false
                };
                if (_this.toolbarSettings.itemClicked) {
                    _this.toolbarSettings.itemClicked.call(_this, eventArgs);
                }
                if (!eventArgs.cancel) {
                    if (args.item.htmlAttributes) {
                        var currentIndex = parseInt(args.item.htmlAttributes['data-index'].split(_this.element.id + '_view_')[1], 10);
                        if (currentIndex !== _this.activeView) {
                            var prevOnChange = _this.isProtectedOnChange;
                            _this.isProtectedOnChange = true;
                            var previousIndex = _this.getIndex(_this.activeView);
                            _this.activeView = parseInt(args.item.htmlAttributes['data-index'].split(_this.element.id + '_view_')[1], 10);
                            _this.updateActiveView(previousIndex);
                            _this.isProtectedOnChange = prevOnChange;
                        }
                    }
                }
            }
        });
        this.toolbarHeader = this.element.querySelector('.e-view-header');
        var toolbarEle = this.createElement('div');
        this.toolbar.appendTo(toolbarEle);
        this.toolbar.element.setAttribute('aria-label', 'assist-view-toolbar-header');
        this.toolbarHeader.appendChild(toolbarEle);
    };
    AIAssistView.prototype.updateHeaderToolbar = function () {
        if (this.toolbarSettings.items.length > 0) {
            /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
            var pushToolbar = this.toolbarSettings.items.map(function (item) { return ({
                type: item.type,
                template: item.template,
                disabled: item.disabled,
                cssClass: item.cssClass,
                visible: item.visible,
                tooltipText: item.tooltip,
                prefixIcon: item.iconCss,
                text: item.text,
                align: item.align,
                tabIndex: item.tabIndex
            }); });
            this.toolbarItems = this.toolbarItems.concat(pushToolbar);
        }
    };
    AIAssistView.prototype.getIndex = function (currentIndex) {
        return (((currentIndex) > (this.views.length - (this.isAssistView ? 1 : 0))) || (currentIndex < 0)) ?
            0 : currentIndex;
    };
    AIAssistView.prototype.updateActiveView = function (previousIndex) {
        var activeViewIndex = this.getIndex(this.activeView);
        if (!this.aiAssistViewRendered) {
            this.appendView(activeViewIndex);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            if (this.toolbar.tbarEle[parseInt(activeViewIndex.toString(), 10)]) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                this.toolbar.tbarEle[parseInt(activeViewIndex.toString(), 10)].classList.add('e-active');
            }
        }
        else if (previousIndex !== activeViewIndex) {
            this.removePreviousView(previousIndex, activeViewIndex);
            this.appendView(activeViewIndex);
        }
        this.previousElement = this.displayContents[parseInt(activeViewIndex.toString(), 10)];
    };
    AIAssistView.prototype.appendView = function (activeViewIndex) {
        //updating the new view section according to the activeView property
        if (activeViewIndex === 0 && this.assistViewTemplateIndex < 0) {
            this.viewWrapper.append(this.contentWrapper, this.footer);
        }
        else if (activeViewIndex === 0 && this.assistViewTemplateIndex >= 0) {
            this.viewWrapper.append(this.assistCustomSection);
        }
        else {
            this.viewWrapper.append(this.displayContents[parseInt(activeViewIndex.toString(), 10)]);
        }
    };
    AIAssistView.prototype.removePreviousView = function (previousIndex, activeViewIndex) {
        // removing the previously binded element
        this.viewWrapper.removeChild(this.previousElement);
        if (previousIndex === 0 && this.assistViewTemplateIndex < 0) {
            this.viewWrapper.removeChild(this.footer);
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (this.toolbar.tbarEle[parseInt(activeViewIndex.toString(), 10)]) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.toolbar.tbarEle[parseInt(activeViewIndex.toString(), 10)].classList.add('e-active');
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (previousIndex >= 0 && this.toolbar.tbarEle[parseInt(previousIndex.toString(), 10)]) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.toolbar.tbarEle[parseInt(previousIndex.toString(), 10)].classList.remove('e-active');
        }
    };
    AIAssistView.prototype.renderDefaultView = function () {
        var viewWrapper = this.element.querySelector('.e-view-content');
        this.createViewComponents(viewWrapper);
        this.contentWrapper = this.element.querySelector('.e-views');
        this.contentWrapper.setAttribute('data-index', this.element.id + '_view_0');
        var contentContainer = this.element.querySelector('.e-view-container');
        this.content = this.getElement('contentContainer');
        this.getFooter();
        this.updateFooterClass(this.footerTemplate);
        this.renderContent();
        this.renderAssistViewFooter();
        this.updateBannerView(contentContainer);
        contentContainer.append(this.content);
        this.checkIsScrollable();
    };
    AIAssistView.prototype.checkIsScrollable = function () {
        if (this.enableScrollToBottom) {
            this.downArrowIcon.visible = this.contentWrapper.scrollHeight > this.contentWrapper.clientHeight;
        }
    };
    AIAssistView.prototype.initializeLocale = function () {
        this.l10n = new L10n('aiassistview', {
            stopResponseText: 'Stop Responding',
            fileSizeFailure: 'Upload failed: {0} files exceeded the maximum size',
            fileCountFailure: 'Upload limit reached: Maximum {0} files allowed. Remove extra files to proceed uploading',
            send: 'Send',
            attachments: 'Attach File',
            clear: 'Clear',
            readAloud: 'Read Aloud',
            stopAudio: 'Stop',
            previousResponse: 'Previous',
            nextResponse: 'Next',
            noRecordsTemplate: 'No records found',
            status: 'Status',
            toolCalls: 'Tool Calls',
            duration: 'Duration',
            streamingChunks: 'Streaming chunks',
            model: 'Model',
            inputTokens: 'Input tokens',
            outputTokens: 'Output tokens',
            totalTokens: 'Total tokens',
            reasoningTokens: 'Reasoning tokens',
            cachedInputTokens: 'Cached input tokens'
        }, this.locale);
        this.l10n.setLocale(this.locale);
    };
    AIAssistView.prototype.toggleStopRespondingButton = function (show) {
        var sendIconClass = 'e-assist-send';
        var stopIconClass = 'e-assist-stop';
        var stopTooltip = this.l10n.getConstant('stopResponseText');
        if (!this.footerTemplate) {
            var currentIconClass_1 = show ? sendIconClass : stopIconClass;
            var newIconClass = show ? stopIconClass : sendIconClass;
            var currentItem = this.footerToolbarEle.items.find(function (item) { return item.prefixIcon === "e-icons " + currentIconClass_1; });
            var itemIndex = this.footerToolbarEle.items.indexOf(currentItem);
            var currentToolbarItemElement = this.footerToolbarEle.element.querySelector(".e-tbar-btn ." + currentIconClass_1) ?
                this.footerToolbarEle.element.querySelector(".e-tbar-btn ." + currentIconClass_1).closest('.e-toolbar-item') : null;
            if (itemIndex !== -1 && currentItem && currentToolbarItemElement) {
                var newItem = {
                    prefixIcon: "e-icons " + newIconClass,
                    align: 'Right',
                    tooltipText: show ? stopTooltip : undefined
                };
                this.footerToolbarEle.addItems([newItem], itemIndex);
                this.footerToolbarEle.removeItems(currentToolbarItemElement);
            }
            this.refreshTextareaUI();
        }
        else {
            var currentIcon = this.footer.querySelector("." + (show ? sendIconClass : stopIconClass));
            if (currentIcon) {
                currentIcon.classList.replace(show ? sendIconClass : stopIconClass, show ? stopIconClass : sendIconClass);
                if (show) {
                    currentIcon.title = stopTooltip;
                    EventHandler.add(currentIcon, 'click', this.respondingStopper, this);
                }
                else {
                    currentIcon.removeAttribute('title');
                    EventHandler.remove(currentIcon, 'click', this.respondingStopper);
                }
            }
        }
    };
    AIAssistView.prototype.hasStopResponseButton = function () {
        if (!this.footerToolbarEle && this.footerTemplate) {
            return this.footer.querySelector('.e-assist-stop') ? true : false;
        }
        else if (this.footerToolbarEle) {
            return this.footerToolbarEle.element.querySelector('.e-assist-stop') ? true : false;
        }
        return false;
    };
    AIAssistView.prototype.finalizeIncompleteThinkingBlocks = function () {
        var prevOnChange = this.isProtectedOnChange;
        this.isProtectedOnChange = true;
        // Step 1: Get last prompt index
        var lastPromptIndex = this.prompts.length - 1;
        if (lastPromptIndex < 0) {
            return;
        } // No prompts yet
        var lastPrompt = this.prompts[parseInt(lastPromptIndex.toString(), 10)];
        if (!lastPrompt.blocks || lastPrompt.blocks.length === 0) {
            return;
        } // No blocks
        // Step 2: Single-pass transform + check for incomplete thinking blocks
        var hasIncompleteThinking = false;
        var finalizedBlocks = lastPrompt.blocks.map(function (block) {
            if (block.blockType === 'thinking') {
                var thinkingBlock = block;
                // Track if this block is incomplete
                if (thinkingBlock.isActive ||
                    (thinkingBlock.stages && thinkingBlock.stages.some(function (s) { return s.status === 'inprogress'; }))) {
                    hasIncompleteThinking = true;
                }
                // Transform block
                return __assign({}, thinkingBlock, { isActive: false, stages: (thinkingBlock.stages || []).map(function (stage) { return (__assign({}, stage, { 
                        // Only change inProgress → failed; keep others
                        status: stage.status.toLowerCase() === 'inprogress' ? 'failed' : stage.status, iconCss: stage.status.toLowerCase() === 'inprogress'
                            ? 'e-icons e-close' // Error icon instead of progress
                            : stage.iconCss })); }) });
            }
            // Non-thinking blocks pass through unchanged
            return block;
        });
        if (!hasIncompleteThinking) {
            this.isProtectedOnChange = prevOnChange;
            return; // Nothing to finalize
        }
        // Step 3: Replace blocks in last prompt (immutable update)
        lastPrompt.blocks = finalizedBlocks;
        this.isProtectedOnChange = prevOnChange;
        // Refresh tool call count from the FINALIZED blocks so the upcoming incomplete
        // report reflects the failure state.
        this.activeTurnToolCalls = this.deriveToolCalls(finalizedBlocks) || 0;
        // Step 4: Re-render existing response without adding new response
        // This updates the existing response with finalized blocks
        this.addPromptResponse({ blocks: finalizedBlocks });
    };
    AIAssistView.prototype.renderContent = function () {
        this.renderOutputContent();
        this.renderSuggestions(this.promptSuggestions, this.promptSuggestionsHeader, this.promptSuggestionItemTemplate, 'promptSuggestion', 'promptSuggestionItemTemplate', this.onSuggestionClick);
        this.renderContentElement();
        if (this.outputElement) {
            this.renderSkeleton();
        }
    };
    AIAssistView.prototype.renderOutputContent = function (isMethodCall) {
        var _this = this;
        this.outputElement = this.getElement('outputElement');
        if (this.responseToolbarSettings.items.length === 0) {
            var prevOnChange = this.isProtectedOnChange;
            this.isProtectedOnChange = true;
            this.responseToolbarSettings.items = [
                { iconCss: 'e-icons e-assist-copy', tooltip: 'Copy', cssClass: 'check' },
                { iconCss: 'e-icons e-assist-like', tooltip: 'Like' },
                { iconCss: 'e-icons e-assist-dislike', tooltip: 'Dislike' }
            ];
            this.isProtectedOnChange = prevOnChange;
        }
        if (this.prompts) {
            this.prompts.forEach(function (prompt, i) {
                if (!_this.originalResponses.has(i)) {
                    _this.originalResponses.set(i, prompt.response || '');
                    _this.originalBlocks.set(i, prompt.blocks || []);
                }
                if (prompt.regeneratedResponses && prompt.regeneratedResponses.length > 0) {
                    var responseStack = [_this.originalResponses.get(i)].concat(prompt.regeneratedResponses);
                    _this.regeneratedResponses.set(i, responseStack);
                    var blocksStack = [_this.originalBlocks.get(i) || []];
                    for (var j = 0; j < prompt.regeneratedResponses.length; j++) {
                        blocksStack.push([]);
                    }
                    _this.regeneratedBlocks.set(i, blocksStack);
                    _this.currentRegeneratedIndex.set(i, responseStack.length - 1);
                    var prevOnChange = _this.isProtectedOnChange;
                    _this.isProtectedOnChange = true;
                    prompt.response = responseStack[responseStack.length - 1];
                    prompt.blocks = [];
                    _this.isProtectedOnChange = prevOnChange;
                }
                _this.renderOutputContainer(SanitizeHtmlHelper.sanitize(prompt.prompt), SanitizeHtmlHelper.sanitize(prompt.response), prompt.attachedFiles, i, undefined, true, prompt.blocks);
            });
        }
        if (this.suggestionsElement && this.content.contains(this.suggestionsElement)) {
            this.content.insertBefore(this.outputElement, this.suggestionsElement);
        }
        else {
            this.content.appendChild(this.outputElement);
        }
        if (isMethodCall) {
            this.aiAssistViewRendered = true;
        }
    };
    AIAssistView.prototype.updateBannerView = function (contentContainer) {
        if (this.prompts.length === 0) {
            this.renderBannerView(this.bannerTemplate, contentContainer, 'bannerTemplate');
        }
    };
    AIAssistView.prototype.renderAssistViewFooter = function () {
        var textareaAndIconsWrapper = this.createElement('div', { attrs: { class: 'e-textarea-icons-wrapper' } });
        if (this.footerTemplate) {
            this.updateContent(this.footerTemplate, this.footer, {}, 'footerTemplate');
        }
        else {
            this.editableTextarea = this.createElement('div', {
                attrs: {
                    class: 'e-assist-textarea',
                    contenteditable: 'true',
                    placeholder: this.promptPlaceholder,
                    role: 'textbox',
                    'aria-multiline': 'true'
                },
                innerHTML: this.prompt
            });
            var hiddenTextarea = this.createElement('textarea', {
                attrs: {
                    class: 'e-hidden-textarea',
                    name: 'userPrompt',
                    value: this.prompt
                }
            });
            this.appendChildren(textareaAndIconsWrapper, this.editableTextarea, hiddenTextarea);
            this.footer.append(textareaAndIconsWrapper);
        }
        if (!this.footerTemplate) {
            var footerIconsWrapper = this.createElement('div', { attrs: { class: 'e-footer-icons-wrapper e-footer-right-items' } });
            this.renderFooterToolbar(footerIconsWrapper);
            textareaAndIconsWrapper.appendChild(footerIconsWrapper);
            this.footer.appendChild(textareaAndIconsWrapper);
            this.footer.classList.add('e-footer-focus-wave-effect');
            this.refreshTextareaUI();
            this.pushToUndoStack(this.prompt);
            this.initializeMentions();
        }
    };
    AIAssistView.prototype.getUploaderElement = function () {
        var uploaderElement = null;
        if (this.footerLeftToolbarEle) {
            uploaderElement = this.footerLeftToolbarEle.element.querySelector('.e-assist-file-upload');
        }
        if (!uploaderElement && this.footerToolbarEle) {
            uploaderElement = this.footerToolbarEle.element.querySelector('.e-assist-file-upload');
        }
        return uploaderElement;
    };
    AIAssistView.prototype.renderFooterToolbar = function (container) {
        var _this = this;
        var customItems = this.footerToolbarSettings.items || [];
        var isInlineMode = (this.footerToolbarSettings.toolbarPosition || '').toLowerCase() !== 'bottom';
        var rightItems = [];
        var leftItems = [];
        for (var _i = 0, customItems_1 = customItems; _i < customItems_1.length; _i++) {
            var customItem = customItems_1[_i];
            var isSttToolbarItem = customItem.iconCss.indexOf('e-assist-speech-to-text') !== -1;
            var mappedItem = {
                type: customItem.type,
                template: isSttToolbarItem && isNOU(customItem.template) ? '<button class="e-assistview-speech-to-text e-tbar-btn"></button>' : customItem.template,
                disabled: customItem.disabled,
                cssClass: customItem.cssClass,
                visible: customItem.visible,
                tooltipText: customItem.tooltip,
                prefixIcon: customItem.iconCss,
                text: customItem.text,
                align: customItem.align,
                tabIndex: customItem.disabled ? -1 : (customItem.tabIndex >= 0 ? customItem.tabIndex : 0)
            };
            if (isInlineMode && customItem.align === 'Left') {
                leftItems.push(mappedItem);
            }
            else {
                rightItems.push(mappedItem);
            }
        }
        if (this.enableAttachments && !this.isDuplicatedItem('e-icons e-assist-attachment-icon', rightItems.concat(leftItems))) {
            this.attachmentToolbarItem = {
                prefixIcon: 'e-icons e-assist-attachment-icon',
                tooltipText: this.l10n.getConstant('attachments'),
                align: 'Right'
            };
            rightItems.push(this.attachmentToolbarItem);
        }
        if (this.speechToTextSettings.enable && !this.isDuplicatedItem('e-icons e-assist-speech-to-text', rightItems.concat(leftItems))) {
            this.speechToTextToolbarItem = {
                id: this.element.id + '_speechtotext',
                template: '<button class="e-assistview-speech-to-text e-tbar-btn"></button>',
                prefixIcon: 'e-icons e-assist-speech-to-text',
                align: 'Right'
            };
            rightItems.push(this.speechToTextToolbarItem);
        }
        if (this.showClearButton && !this.isDuplicatedItem('e-icons e-assist-clear-icon', rightItems.concat(leftItems))) {
            this.clearToolbarItem = {
                prefixIcon: 'e-icons e-assist-clear-icon',
                tooltipText: this.l10n.getConstant('clear'),
                align: 'Right'
            };
            rightItems.push(this.clearToolbarItem);
        }
        if (!this.isDuplicatedItem('e-icons e-assist-send', rightItems.concat(leftItems))) {
            this.sendToolbarItem = {
                prefixIcon: 'e-icons e-assist-send',
                align: 'Right'
            };
            rightItems.push(this.sendToolbarItem);
        }
        var toolbarClickHandler = function (args) {
            var eventItemArgs = {
                type: args.item.type,
                text: args.item.text,
                iconCss: args.item.prefixIcon,
                cssClass: args.item.cssClass,
                tooltip: args.item.tooltipText,
                template: args.item.template,
                disabled: args.item.disabled,
                visible: args.item.visible,
                align: args.item.align,
                tabIndex: args.item.tabIndex
            };
            var eventArgs = {
                item: eventItemArgs,
                event: args.originalEvent,
                cancel: false
            };
            if (_this.footerToolbarSettings.itemClick) {
                _this.footerToolbarSettings.itemClick.call(_this, eventArgs);
            }
            if (!eventArgs.cancel) {
                switch (args.item.prefixIcon) {
                    case 'e-icons e-assist-send':
                        if (!_this.isResponseRequested && !args.item.disabled) {
                            _this.onSendIconClick();
                        }
                        break;
                    case 'e-icons e-assist-stop':
                        _this.respondingStopper(args.originalEvent);
                        break;
                    case 'e-icons e-assist-clear-icon':
                        _this.clearIconHandler();
                        break;
                    case 'e-icons e-assist-attachment-icon':
                        if (_this.uploaderObj && _this.attachmentToolbarItem) {
                            var uploaderElement = _this.getUploaderElement();
                            if (!uploaderElement) {
                                _this.updateAttachmentElement();
                                uploaderElement = _this.getUploaderElement();
                            }
                            if (uploaderElement) {
                                uploaderElement.click();
                            }
                        }
                        break;
                }
            }
        };
        this.footerToolbarEle = new Toolbar({
            items: rightItems,
            enableRtl: this.enableRtl,
            width: '100%',
            clicked: toolbarClickHandler
        });
        var toolbarContainer = this.createElement('div');
        this.footerToolbarEle.appendTo(toolbarContainer);
        this.footerToolbarEle.element.setAttribute('aria-label', 'assist-footer-toolbar');
        container.appendChild(toolbarContainer);
        if (isInlineMode && leftItems.length > 0) {
            this.footerLeftToolbarEle = new Toolbar({
                items: leftItems,
                enableRtl: this.enableRtl,
                width: '100%',
                clicked: toolbarClickHandler
            });
            var leftToolbarContainer = this.createElement('div');
            this.footerLeftToolbarEle.appendTo(leftToolbarContainer);
            this.footerLeftToolbarEle.element.setAttribute('aria-label', 'assist-footer-left-toolbar');
            var leftItemsContainer = this.createElement('div', {
                attrs: { class: 'e-footer-left-items' }
            });
            leftItemsContainer.appendChild(leftToolbarContainer);
            this.insertLeftItems(leftItemsContainer);
        }
        this.updateAttachmentElement();
        this.renderSpeechToText();
    };
    AIAssistView.prototype.insertLeftItems = function (leftItems) {
        var textareaAndIconsWrapper = this.footer.querySelector('.e-textarea-icons-wrapper');
        if (!textareaAndIconsWrapper) {
            return;
        }
        var textarea = textareaAndIconsWrapper.querySelector('.e-assist-textarea');
        if (textarea) {
            textareaAndIconsWrapper.insertBefore(leftItems, textarea);
        }
        else {
            textareaAndIconsWrapper.appendChild(leftItems);
        }
    };
    AIAssistView.prototype.isDuplicatedItem = function (iconCss, toolbarItems) {
        for (var _i = 0, toolbarItems_1 = toolbarItems; _i < toolbarItems_1.length; _i++) {
            var item = toolbarItems_1[_i];
            if ((item.prefixIcon || '') === iconCss) {
                switch (iconCss) {
                    case 'e-icons e-assist-send':
                        this.sendToolbarItem = item;
                        break;
                    case 'e-icons e-assist-clear-icon':
                        this.clearToolbarItem = item;
                        break;
                    case 'e-icons e-assist-attachment-icon':
                        this.attachmentToolbarItem = item;
                        break;
                }
                return true;
            }
        }
        return false;
    };
    AIAssistView.prototype.updateAttachmentElement = function () {
        if (this.enableAttachments && this.attachmentToolbarItem) {
            this.renderAttachmentIcon();
        }
        else {
            if (this.uploaderObj) {
                this.uploaderObj.destroy();
                this.dropArea.innerHTML = '';
                remove(this.dropArea);
            }
        }
    };
    AIAssistView.prototype.renderSpeechToText = function () {
        var _this = this;
        if (this.speechToTextObj) {
            this.speechToTextObj.destroy();
            this.speechToTextObj = null;
        }
        if (this.speechToTextSettings.enable) {
            this.speechToTextObj = new SpeechToText({
                allowInterimResults: this.speechToTextSettings.allowInterimResults,
                transcript: this.speechToTextSettings.transcript,
                lang: this.speechToTextSettings.lang,
                listeningState: this.speechToTextSettings.listeningState,
                disabled: this.speechToTextSettings.disabled,
                buttonSettings: this.speechToTextSettings.buttonSettings,
                showTooltip: this.speechToTextSettings.showTooltip,
                tooltipSettings: this.speechToTextSettings.tooltipSettings,
                cssClass: this.speechToTextSettings.cssClass,
                onStart: function (args) {
                    if (_this.speechToTextSettings.onStart) {
                        _this.speechToTextSettings.onStart.call(_this, args);
                    }
                },
                onStop: function (args) {
                    if (_this.speechToTextSettings.onStop) {
                        _this.speechToTextSettings.onStop.call(_this, args);
                    }
                },
                transcriptChanged: function (args) {
                    var prevOnChange = _this.isProtectedOnChange;
                    _this.isProtectedOnChange = true;
                    var value = _this.prompt.length > 0 ? _this.prompt + ' ' : '';
                    if (args.isInterimResult) {
                        _this.editableTextarea.innerHTML = value + SanitizeHtmlHelper.sanitize(args.transcript);
                        _this.editableTextarea.focus();
                        _this.setFocusAtEnd(_this.editableTextarea);
                    }
                    else {
                        var prevPrompt = _this.prompt;
                        _this.prompt = value + SanitizeHtmlHelper.sanitize(args.transcript);
                        _this.editableTextarea.innerHTML = _this.prompt;
                        _this.speechToTextObj.transcript = '';
                        _this.editableTextarea.focus();
                        _this.setFocusAtEnd(_this.editableTextarea);
                        _this.triggerPromptChanged(event, prevPrompt);
                    }
                    _this.refreshTextareaUI();
                    // Debounced push to undo stack
                    _this.scheduleUndoPush();
                    _this.redoStack = [];
                    _this.speechToTextSettings.transcript = args.transcript;
                    if (_this.speechToTextSettings.transcriptChanged) {
                        _this.speechToTextSettings.transcriptChanged.call(_this, args);
                    }
                    _this.isProtectedOnChange = prevOnChange;
                },
                onError: function (args) {
                    if (_this.speechToTextSettings.onError) {
                        _this.speechToTextSettings.onError.call(_this, args);
                    }
                }
            });
            var speechToTextButton = null;
            if (this.footerLeftToolbarEle) {
                speechToTextButton = this.footerLeftToolbarEle.element.querySelector('.e-assistview-speech-to-text');
            }
            if (!speechToTextButton && this.footerToolbarEle) {
                speechToTextButton = this.footerToolbarEle.element.querySelector('.e-assistview-speech-to-text');
            }
            if (speechToTextButton) {
                this.speechToTextObj.appendTo(speechToTextButton);
            }
        }
    };
    AIAssistView.prototype.initializeMentions = function () {
        if (!this.mentions || this.mentions.length === 0 || !this.editableTextarea) {
            return;
        }
        var prevOnChange = this.isProtectedOnChange;
        this.isProtectedOnChange = true;
        for (var _i = 0, _a = this.mentions; _i < _a.length; _i++) {
            var settings = _a[_i];
            if (!settings.mentionChar) {
                continue; // Skip entries with empty mentionChar
            }
            var displayTemplate = settings.displayTemplate || this.getMentionElement(settings);
            var noRecordsTemplate = settings.noRecordsTemplate || this.l10n.getConstant('noRecordsTemplate');
            var mentionInstance = new Mention({
                mentionChar: settings.mentionChar,
                dataSource: settings.dataSource,
                fields: settings.fields,
                query: settings.query,
                filterType: settings.filterType,
                highlight: settings.highlight,
                popupWidth: settings.popupWidth,
                popupHeight: settings.popupHeight,
                cssClass: this.enableRtl ? 'e-assist-mention e-rtl' : 'e-assist-mention',
                requireLeadingSpace: false,
                suffixText: '&nbsp;',
                allowSpaces: true,
                displayTemplate: displayTemplate,
                itemTemplate: settings.itemTemplate,
                noRecordsTemplate: noRecordsTemplate,
                change: this.onMentionUpdated.bind(this, settings.mentionChar),
                select: this.onMentionSelect.bind(this)
            }, this.editableTextarea);
            this.mentionModels.push(mentionInstance);
        }
        this.isProtectedOnChange = prevOnChange;
    };
    AIAssistView.prototype.getMentionElement = function (mentionItem, itemData) {
        var iconCssFieldName = mentionItem.fields.iconCss;
        var hasIconCss = false;
        var iconCssValue = '';
        if (itemData) {
            // eslint-disable-next-line security/detect-object-injection
            iconCssValue = itemData[iconCssFieldName] || itemData.iconCss || '';
            hasIconCss = !isNOU(iconCssValue) && typeof iconCssValue === 'string' && iconCssValue.trim() !== '';
        }
        else if (mentionItem.dataSource && mentionItem.dataSource.length > 0) {
            var firstItem = mentionItem.dataSource[0];
            // eslint-disable-next-line security/detect-object-injection
            var iconValue = firstItem[iconCssFieldName];
            hasIconCss = !isNOU(iconValue) && typeof iconValue === 'string' && iconValue.trim() !== '';
        }
        var shouldShowMentionChar = !hasIconCss && (!isNOU(mentionItem.showMentionChar) ? mentionItem.showMentionChar : true);
        var textContent = '';
        if (itemData) {
            var textFieldName = mentionItem.fields.text;
            // eslint-disable-next-line security/detect-object-injection
            var textValue = itemData[textFieldName] || itemData.text;
            textContent = !isNOU(textValue) ? String(textValue) : '';
        }
        else {
            textContent = '${' + mentionItem.fields.text + '}';
        }
        var mentionHTMLContent = (hasIconCss ? (itemData
            ? "<span class=\"" + iconCssValue + "\"></span>"
            : "<span class=\"${" + mentionItem.fields.iconCss + "}\"></span>")
            : '') +
            (shouldShowMentionChar ? "<span class=\"e-mention-char\">" + mentionItem.mentionChar + "</span>" : '') +
            '<span class="e-aiassist-mention-item-chip">' +
            textContent +
            '</span>';
        return mentionHTMLContent;
    };
    AIAssistView.prototype.renderAttachmentIcon = function () {
        var _this = this;
        this.dropArea = this.createElement('div', { attrs: { class: 'e-assist-drop-area' } });
        this.footer.prepend(this.dropArea);
        var attachmentIcon = null;
        if (this.footerLeftToolbarEle) {
            attachmentIcon = this.footerLeftToolbarEle.element.querySelector('.e-assist-attachment-icon');
        }
        if (!attachmentIcon && this.footerToolbarEle) {
            attachmentIcon = this.footerToolbarEle.element.querySelector('.e-assist-attachment-icon');
        }
        var uploaderElement = this.createElement('input', { attrs: { class: 'e-assist-file-upload', type: 'file', name: 'UploadFiles', id: 'fileUpload' } });
        attachmentIcon.appendChild(uploaderElement);
        this.uploaderObj = new Uploader({
            asyncSettings: {
                saveUrl: this.attachmentSettings.saveUrl,
                removeUrl: this.attachmentSettings.removeUrl
            },
            maxFileSize: this.attachmentSettings.maxFileSize,
            allowedExtensions: this.attachmentSettings.allowedFileTypes,
            progress: this.onUploadProgress.bind(this),
            success: this.onUploadSuccess.bind(this),
            failure: this.onUploadFailure.bind(this),
            uploading: this.onUploadStart.bind(this),
            removing: this.onAttachmentRemoving.bind(this),
            multiple: true,
            dropArea: this.footer,
            selected: function (args) {
                var oversized = args.filesData.filter(function (file) {
                    return file.status === _this.uploaderObj.l10n.getConstant('invalidMaxFileSize') && file.statusCode === '0';
                });
                if (oversized.length) {
                    _this.showFailureAlert('fileSizeFailure', oversized.length, 'e-size-failure');
                    uploaderElement.value = '';
                }
                var totalSelected = args.filesData.length + _this.uploadedFiles.length;
                if (totalSelected > _this.attachmentSettings.maximumCount) {
                    args.cancel = true;
                    _this.showFailureAlert('fileCountFailure', _this.attachmentSettings.maximumCount, 'e-count-failure');
                    uploaderElement.value = '';
                    return;
                }
            }
        });
        this.uploaderObj.appendTo(uploaderElement);
    };
    AIAssistView.prototype.showFailureAlert = function (localeConstantKey, fileCount, failureType) {
        var failureMessage = this.l10n.getConstant(localeConstantKey).replace('{0}', fileCount.toString());
        if (fileCount === 1) {
            failureMessage = failureMessage.replace('files', 'file');
        }
        this.createFailureAlert(failureMessage, failureType);
    };
    AIAssistView.prototype.createFailureAlert = function (failureMessage, failureType) {
        var _this = this;
        var failureAlert = this.renderFailureAlert(this.viewWrapper, failureMessage, failureType, 'e-assist-circle-close', 'e-assist-clear-icon');
        if (this.viewWrapper.contains(this.footer)) {
            this.viewWrapper.insertBefore(failureAlert, this.footer);
        }
        failureAlert.classList.add('e-show');
        setTimeout(function () {
            _this.handleFailureAlertRemove(_this.viewWrapper, failureAlert);
        }, 3000);
    };
    AIAssistView.prototype.onUploadStart = function (args) {
        this.trigger('beforeAttachmentUpload', args);
        this.uploadedFiles.push(args.fileData);
        var fileItem = this.createFileItem(args.fileData, true);
        this.dropArea.appendChild(fileItem);
    };
    AIAssistView.prototype.onUploadProgress = function (args) {
        var uploadProgress = args.e.loaded / args.e.total * 100;
        var progressFill = this.footer.querySelector("#e-assist-progress-" + CSS.escape(args.file.name));
        if (progressFill) {
            progressFill.style.width = uploadProgress + "%";
        }
    };
    AIAssistView.prototype.onMentionUpdated = function (mentionChar, args) {
        var mentionId = (++this.mentionCounter).toString();
        var mentionElements = this.editableTextarea.querySelectorAll('.e-mention-chip');
        var mentionElement = mentionElements[mentionElements.length - 1];
        if (mentionElement) {
            mentionElement.setAttribute('data-mention-id', mentionId);
            this.selectedMentions.push({
                itemData: args.itemData,
                element: mentionElement,
                mentionChar: mentionChar
            });
        }
    };
    AIAssistView.prototype.onMentionSelect = function (args) {
        var eventArgs = {
            cancel: false,
            event: args.e,
            isInteracted: args.isInteracted,
            itemData: args.itemData
        };
        this.trigger('mentionSelect', eventArgs);
        // If the event handler cancelled the selection, propagate it to the Mention control
        if (eventArgs.cancel) {
            args.cancel = true;
        }
    };
    AIAssistView.prototype.restoreMentionsFromPrompt = function (promptIndex) {
        // Reset the selectedMentions and counter
        this.selectedMentions = [];
        this.mentionCounter = 0;
        // Get the stored mentions from the prompt data
        var storedMentions = this.prompts[parseInt(promptIndex.toString(), 10)].mentions;
        if (!storedMentions || storedMentions.length === 0 || !this.editableTextarea) {
            return;
        }
        // Get the rendered chips from the textarea
        var mentionElements = this.editableTextarea.querySelectorAll('.e-mention-chip');
        // Rebuild selectedMentions array by matching stored mentions to rendered chips
        for (var i = 0; i < mentionElements.length; i++) {
            var mentionElement = mentionElements[parseInt(i.toString(), 10)];
            var mentionId = (++this.mentionCounter).toString();
            mentionElement.setAttribute('data-mention-id', mentionId);
            // Match the chip with the corresponding stored mention
            if (i < storedMentions.length) {
                var storedMention = storedMentions[parseInt(i.toString(), 10)];
                this.selectedMentions.push({
                    itemData: storedMention.itemData,
                    element: mentionElement,
                    mentionChar: storedMention.mentionChar
                });
            }
        }
    };
    AIAssistView.prototype.onUploadSuccess = function (args) {
        if (args.operation === 'upload') {
            this.trigger('attachmentUploadSuccess', args);
            var progressFill = this.footer.querySelector("#e-assist-progress-" + CSS.escape(args.file.name));
            if (progressFill) {
                progressFill.style.width = '100%';
                this.cleanupFileItem(args.file.name);
            }
            var progressBar = this.footer.querySelector('.e-assist-progress-fill');
            if (!progressBar) {
                this.checkAndActivateSendIcon();
            }
        }
        else if (args.operation === 'remove') {
            this.trigger('attachmentRemoved', args);
        }
    };
    AIAssistView.prototype.cleanupFileItem = function (fileName) {
        var fileItem = this.footer.querySelector("#e-assist-progress-" + CSS.escape(fileName));
        if (fileItem) {
            fileItem.parentElement.remove();
        }
    };
    /**
     * Handles the internal Uploader's `removing` event and forwards it to the public
     * `attachmentRemoving` event. The same args object reference is passed through, so any
     * changes made by the consumer (`args.cancel`, `args.customFormData`, `args.postRawFile`)
     * are honored by the Uploader before the remove request is dispatched.
     *
     * @param {RemovingEventArgs} args - Specifies the removing event arguments from the Uploader.
     * @returns {void}
     */
    AIAssistView.prototype.onAttachmentRemoving = function (args) {
        this.trigger('attachmentRemoving', args);
        this.isAttachmentRemovalCancelled = !!args.cancel;
    };
    AIAssistView.prototype.onUploadFailure = function (args) {
        if (args.operation === 'remove') {
            this.trigger('attachmentRemoved', args);
        }
        else {
            this.trigger('attachmentUploadFailure', args);
            this.uploaderObj.remove(args.file);
            this.uploadedFiles = this.uploadedFiles.filter(function (file) { return file.name !== args.file.name; });
            var progressFill = this.footer.querySelector("#e-assist-progress-" + CSS.escape(args.file.name));
            if (progressFill) {
                progressFill.style.width = '100%';
                progressFill.classList.add('e-assist-upload-failed');
            }
        }
    };
    AIAssistView.prototype.createFileItem = function (fileData, isForFooter) {
        var _this = this;
        var fileItem = this.createElement('div', { className: 'e-assist-uploaded-file-item' });
        if (this.attachmentSettings.attachmentTemplate) {
            var introContainer = this.createElement('div', { className: 'e-attachment-template' });
            fileItem.appendChild(introContainer);
            this.getContextObject('attachmenttemplate', introContainer, -1, -1, fileData);
        }
        else {
            var fileIcon = this.createElement('div', {
                className: 'e-assist-file-icon-svg'
            });
            fileIcon.appendChild(this.createFileTypeIcon(fileData.name));
            var fileDetails = this.createElement('div', { className: 'e-assist-file-details' });
            var fileName = this.createElement('span', { className: 'e-assist-file-name', innerHTML: fileData.name });
            var fileSize = this.createElement('span', { className: 'e-assist-file-size', innerHTML: (fileData.size / 1024).toFixed(2) + " KB" });
            fileDetails.append(fileName, fileSize);
            fileItem.append(fileIcon, fileDetails);
        }
        var progressBar = this.createElement('div', { className: 'e-assist-progress-bar' });
        var progressFill = this.createElement('div', { id: "e-assist-progress-" + fileData.name, className: 'e-assist-progress-fill' });
        progressBar.appendChild(progressFill);
        var closeButton;
        if (isForFooter) {
            closeButton = this.createElement('span', { attrs: { class: 'e-icons e-assist-clear-icon', role: 'button', 'aria-label': 'Clear file', tabindex: '-1' } });
            EventHandler.add(closeButton, 'click', function () { return _this.handleRemoveUploadedFile(closeButton, fileData, fileItem); });
            fileItem.append(closeButton);
        }
        fileItem.append(progressBar);
        EventHandler.add(fileItem, 'click', function (event) {
            if (closeButton && (event.target === closeButton || event.target.classList.contains('e-assist-clear-icon'))) {
                return;
            }
            _this.handleAttachmentPreview(fileData);
        });
        return fileItem;
    };
    AIAssistView.prototype.handleAttachmentPreview = function (file) {
        var eventArgs = {};
        if (this.attachmentSettings.attachmentClick) {
            this.attachmentSettings.attachmentClick.call(this, eventArgs);
        }
    };
    AIAssistView.prototype.handleRemoveUploadedFile = function (closeButton, fileData, fileItem) {
        this.uploaderObj.remove(fileData);
        if (this.isAttachmentRemovalCancelled) {
            return;
        }
        this.uploadedFiles = this.uploadedFiles.filter(function (file) { return file.name !== fileData.name; });
        EventHandler.remove(closeButton, 'click', this.handleRemoveUploadedFile);
        fileItem.remove();
        this.checkAndActivateSendIcon();
    };
    AIAssistView.prototype.applyPromptChange = function (newState, oldState, event) {
        var prevOnChange = this.isProtectedOnChange;
        this.isProtectedOnChange = true;
        this.prompt = this.editableTextarea.innerHTML = newState.content;
        this.isProtectedOnChange = prevOnChange;
        this.refreshTextareaUI();
        this.setCursorPosition(newState.selectionStart, newState.selectionEnd);
        this.triggerPromptChanged(event, oldState.content);
    };
    AIAssistView.prototype.handleInput = function (event) {
        var textareaEle = event.target;
        var isEmpty = textareaEle.innerHTML === '<br>';
        if (isEmpty) {
            this.clearBreakTags(textareaEle);
        }
        var textContent = textareaEle.innerHTML;
        var prevOnChange = this.isProtectedOnChange;
        this.isProtectedOnChange = true;
        var prevPrompt = this.prompt;
        if (this.selectedMentions.length > 0) {
            this.prompt = this.getPromptTextWithPlaceholders();
        }
        else {
            this.prompt = SanitizeHtmlHelper.sanitize(textContent);
        }
        this.isProtectedOnChange = prevOnChange;
        this.refreshTextareaUI();
        this.editableTextarea.focus();
        // Debounced push to undo stack
        this.scheduleUndoPush();
        this.redoStack = [];
        this.triggerPromptChanged(event, prevPrompt);
    };
    AIAssistView.prototype.triggerPromptChanged = function (event, prevPrompt) {
        var eventArgs = {
            value: this.prompt,
            previousValue: prevPrompt,
            event: event,
            element: (event && event.currentTarget) || this.editableTextarea
        };
        this.trigger('promptChanged', eventArgs);
    };
    AIAssistView.prototype.footerKeyHandler = function (e) {
        var targetElement = e.target;
        if (targetElement.classList.contains('e-tbar-btn') && targetElement.querySelector('.e-assist-attachment-icon')) {
            return;
        }
        this.keyHandler(e, 'footer');
    };
    AIAssistView.prototype.bindScroll = function () {
        if (this.contentWrapper) {
            EventHandler.add(this.contentWrapper, 'scroll', this.handleScroll, this);
        }
        if (this.enableScrollToBottom && this.downArrowIcon && this.downArrowIcon.element) {
            EventHandler.add(this.downArrowIcon.element, 'click', this.scrollBtnClick, this);
        }
    };
    AIAssistView.prototype.unBindScroll = function () {
        if (this.contentWrapper) {
            EventHandler.remove(this.contentWrapper, 'scroll', this.handleScroll);
        }
        if (this.enableScrollToBottom && this.downArrowIcon && this.downArrowIcon.element) {
            EventHandler.remove(this.downArrowIcon.element, 'click', this.scrollBtnClick);
        }
    };
    AIAssistView.prototype.attachFooterIconHandlersTo = function (container) {
        EventHandler.add(container, 'pointerdown', this.onFooterIconsPointerDown, this);
        EventHandler.add(container, 'click', this.onFooterIconsClick, this);
        EventHandler.add(container, 'focusout', this.onFooterIconsFocusOut, this);
    };
    AIAssistView.prototype.removeFooterIconHandlersFrom = function (container) {
        EventHandler.remove(container, 'pointerdown', this.onFooterIconsPointerDown);
        EventHandler.remove(container, 'click', this.onFooterIconsClick);
        EventHandler.remove(container, 'focusout', this.onFooterIconsFocusOut);
    };
    AIAssistView.prototype.wireEvents = function () {
        this.wireFooterEvents(this.footerTemplate);
        if (this.editableTextarea) {
            var footerIconsWrapper = this.footer.querySelector('.e-footer-icons-wrapper');
            if (footerIconsWrapper) {
                this.attachFooterIconHandlersTo(footerIconsWrapper);
            }
            var footerLeftItems = this.footer.querySelector('.e-footer-left-items');
            if (footerLeftItems) {
                this.attachFooterIconHandlersTo(footerLeftItems);
            }
        }
        if (this.enableScrollToBottom) {
            this.bindScroll();
        }
    };
    /*
     * Telemetry — helper methods.
     * Maps onPropertyChanged / addPromptResponse activity into a TelemetryReport,
     * delivers it through the configured hooks, and renders the hover tooltip UI.
     */
    /**
     * Wipes the in-flight telemetry accumulators for the current turn.
     * Re-zeroes the start timestamp, chunk count, and tool call list so the next
     * turn starts clean.
     *
     * @returns {void}
     */
    AIAssistView.prototype.resetActiveTurn = function () {
        this.activeTurnStartTs = 0;
        this.activeTurnChunkCount = 0;
        this.activeTurnToolCalls = 0;
    };
    /**
     * Counts the tool invocations across the given response blocks. Each `tool`
     * block contributes one count, mirroring the prior `TelemetryToolCall[]` shape
     * but as a scalar so the telemetry payload stays small and the public
     * `TelemetryReport.toolCalls` field is a plain `number`.
     *
     * @param {ResponseBlock[]} blocks - The accumulated response blocks for the current turn.
     * @returns {number | undefined} The tool call count, or `undefined` when `blocks`
     * is missing/empty.
     */
    AIAssistView.prototype.deriveToolCalls = function (blocks) {
        if (!blocks || blocks.length === 0) {
            return undefined;
        }
        var count = 0;
        for (var _i = 0, blocks_1 = blocks; _i < blocks_1.length; _i++) {
            var block = blocks_1[_i];
            if (block && block.blockType === 'tool') {
                count++;
            }
        }
        return count;
    };
    /**
     * Renders a millisecond duration for the toolbar label and the tooltip `Duration`
     * row, returning `"—"` for missing values and switching to a two-decimal `s` once
     * the value reaches 1 s so the toolbar and tooltip stay visually identical.
     *
     * @param {number | undefined | null} durationMs - Measured turn duration in milliseconds.
     * @returns {string} `"—"` when missing/non-positive, `ms` value when below 1 s,
     * otherwise the formatted two-decimal `s` value.
     */
    AIAssistView.prototype.formatDuration = function (durationMs) {
        if (typeof durationMs !== 'number' || durationMs <= 0) {
            return '\u2014';
        }
        return durationMs >= 1000
            ? (durationMs / 1000).toFixed(2) + ' s'
            : durationMs + ' ms';
    };
    /**
     * Creates a telemetry report for the current AI interaction.
     * Accepts the turn status and optional telemetry enrichment data.
     *
     * @param {('completed' | 'cancelled')} status - Specifies the completion status of the turn.
     * @param {TelemetryData} [telemetryData] - Provides optional model, token, and custom telemetry data.
     * @returns {TelemetryReport} Returns the generated telemetry report.
     */
    AIAssistView.prototype.buildReport = function (status, telemetryData) {
        var report = {
            status: status,
            toolCalls: this.activeTurnToolCalls,
            duration: this.activeTurnStartTs
                ? Math.round(performance.now() - this.activeTurnStartTs)
                : undefined,
            streamingChunks: this.activeTurnChunkCount
        };
        if (telemetryData) {
            if (!isNullOrUndefined(telemetryData.model)) {
                report.model = telemetryData.model;
            }
            if (!isNullOrUndefined(telemetryData.inputTokens)) {
                report.inputTokens = telemetryData.inputTokens;
            }
            if (!isNullOrUndefined(telemetryData.outputTokens)) {
                report.outputTokens = telemetryData.outputTokens;
            }
            if (!isNullOrUndefined(telemetryData.reasoningTokens)) {
                report.reasoningTokens = telemetryData.reasoningTokens;
            }
            if (!isNullOrUndefined(telemetryData.cachedInputTokens)) {
                report.cachedInputTokens = telemetryData.cachedInputTokens;
            }
            if (!isNullOrUndefined(telemetryData.customAttributes)) {
                report.customAttributes = telemetryData.customAttributes;
            }
        }
        if (!isNullOrUndefined(report.inputTokens) || !isNullOrUndefined(report.outputTokens)) {
            var inputTokens = typeof report.inputTokens === 'number' ? report.inputTokens : 0;
            var outputTokens = typeof report.outputTokens === 'number' ? report.outputTokens : 0;
            report.totalTokens = inputTokens + outputTokens;
        }
        return report;
    };
    /**
     * Processes a telemetry report before delivery.
     * Return a modified report, null to suppress delivery, or void to keep it unchanged.
     *
     * @param {TelemetryReport} report - Specifies the telemetry report to process.
     * @returns {TelemetryReport | null} Returns the processed report or null to suppress delivery.
     */
    AIAssistView.prototype.applyBeforeReport = function (report) {
        if (!this.telemetrySettings || typeof this.telemetrySettings.beforeReport !== 'function') {
            return report;
        }
        var result = this.telemetrySettings.beforeReport(report);
        if (result === null) {
            return null;
        }
        if (result === undefined) {
            return report;
        }
        return result;
    };
    /**
     * Filters a telemetry report based on the configured metrics list.
     * Returns the full report when no metric filter is specified.
     *
     * @param {TelemetryReport} report - Specifies the telemetry report to filter.
     * @returns {TelemetryReport} Returns the filtered telemetry report.
     */
    AIAssistView.prototype.applyMetricsFilter = function (report) {
        if (!this.telemetrySettings || !this.telemetrySettings.metrics || this.telemetrySettings.metrics.length === 0) {
            return report;
        }
        var allow = new Set(this.telemetrySettings.metrics);
        var filtered = {
            status: report.status,
            duration: report.duration
        };
        if (allow.has('toolCalls')) {
            filtered.toolCalls = report.toolCalls;
        }
        if (allow.has('streamingChunks')) {
            filtered.streamingChunks = report.streamingChunks;
        }
        if (allow.has('model')) {
            filtered.model = report.model;
        }
        if (allow.has('inputTokens')) {
            filtered.inputTokens = report.inputTokens;
        }
        if (allow.has('outputTokens')) {
            filtered.outputTokens = report.outputTokens;
        }
        if (allow.has('totalTokens')) {
            filtered.totalTokens = report.totalTokens;
        }
        if (allow.has('reasoningTokens')) {
            filtered.reasoningTokens = report.reasoningTokens;
        }
        if (allow.has('cachedInputTokens')) {
            filtered.cachedInputTokens = report.cachedInputTokens;
        }
        if (!isNullOrUndefined(report.customAttributes)) {
            filtered.customAttributes = report.customAttributes;
        }
        return filtered;
    };
    /**
     * Generates, processes, and dispatches a telemetry report for the current turn.
     * Accepts the turn status and optional telemetry enrichment data.
     *
     * @param {('completed' | 'cancelled')} status - Specifies the completion status of the turn.
     * @param {TelemetryData} [telemetryData] - Provides optional model, token, and custom telemetry data.
     * @returns {void}
     */
    AIAssistView.prototype.emitTelemetryReport = function (status, telemetryData) {
        var settings = this.telemetrySettings;
        if (!settings || settings.enable !== true) {
            this.resetActiveTurn();
            return;
        }
        var before = this.buildReport(status, telemetryData);
        var filtered = this.applyBeforeReport(before);
        if (filtered === null) {
            this.resetActiveTurn();
            return;
        }
        var finalReport = this.applyMetricsFilter(filtered);
        if (finalReport && this.prompts && this.prompts.length > 0) {
            var lastPromptIndex = this.prompts.length - 1;
            this.telemetryReportsByPrompt.set(lastPromptIndex, finalReport);
            // If the toolbar item was skipped at render time (no prior report), inject it now.
            this.ensureTelemetryToolbarItem(lastPromptIndex, finalReport);
            this.updateTelemetryToolbarItem(lastPromptIndex, finalReport);
        }
        this.resetActiveTurn();
    };
    /**
     * Creates the content displayed in the telemetry tooltip.
     * Shows available telemetry metrics in the configured display order.
     *
     * @param {TelemetryReport} report - Specifies the telemetry report to render.
     * @returns {HTMLElement} Returns the populated tooltip content element.
     */
    AIAssistView.prototype.formatTelemetryTooltip = function (report) {
        var wrap = this.createElement('div', { className: 'e-assist-telemetry-tooltip-body' });
        var durationValue = this.formatDuration(report.duration);
        var allFields = {
            status: { label: this.l10n.getConstant('status'), value: report.status },
            toolCalls: { label: this.l10n.getConstant('toolCalls'), value: typeof report.toolCalls === 'number' ? report.toolCalls : 0 },
            duration: { label: this.l10n.getConstant('duration'), value: durationValue },
            streamingChunks: { label: this.l10n.getConstant('streamingChunks'), value: report.streamingChunks },
            model: { label: this.l10n.getConstant('model'), value: report.model },
            inputTokens: { label: this.l10n.getConstant('inputTokens'), value: report.inputTokens },
            outputTokens: { label: this.l10n.getConstant('outputTokens'), value: report.outputTokens },
            totalTokens: { label: this.l10n.getConstant('totalTokens'), value: report.totalTokens },
            reasoningTokens: { label: this.l10n.getConstant('reasoningTokens'), value: report.reasoningTokens },
            cachedInputTokens: { label: this.l10n.getConstant('cachedInputTokens'), value: report.cachedInputTokens }
        };
        // Use typed status mappings and fall back for unexpected values.
        var statusLabels = {
            completed: 'Completed',
            cancelled: 'Cancelled'
        };
        var defaultOrder = [
            'duration', 'toolCalls', 'model', 'inputTokens',
            'outputTokens', 'totalTokens'
        ];
        var requested = this.telemetrySettings.metrics;
        var order = (requested && requested.length > 0) ? requested : defaultOrder;
        // Show count-based metrics only when value is greater than zero.
        var countMetrics = new Set([
            'toolCalls',
            'inputTokens',
            'outputTokens',
            'totalTokens',
            'reasoningTokens',
            'cachedInputTokens',
            'streamingChunks'
        ]);
        var fields = [];
        for (var i = 0; i < order.length; i++) {
            var metric = order[parseInt(i.toString(), 10)];
            // eslint-disable-next-line security/detect-object-injection
            var field = allFields[metric];
            if (!field) {
                continue;
            }
            var hasDataValue = false;
            if (metric === 'status') {
                hasDataValue = (!isNullOrUndefined(field.value));
            }
            else if (countMetrics.has(metric)) {
                // Strict-positive check: hides the row when the metric is absent,
                // null, or explicitly reported as 0 / NaN / negative.
                hasDataValue = (typeof field.value === 'number' && isFinite(field.value) && field.value > 0);
            }
            else {
                hasDataValue = (!isNullOrUndefined(field.value) && String(field.value).length > 0);
            }
            if (hasDataValue) {
                fields.push(field);
            }
        }
        // Render collected fields
        for (var i = 0; i < fields.length; i++) {
            // eslint-disable-next-line security/detect-object-injection
            var field = fields[i];
            var row = this.createElement('div', { className: 'e-assist-telemetry-row' });
            var label = this.createElement('span', { className: 'e-assist-telemetry-label' });
            label.textContent = field.label;
            var value = this.createElement('span', { className: 'e-assist-telemetry-value' });
            if (field.label === 'Status') {
                var rawStatus = String(field.value);
                // eslint-disable-next-line security/detect-object-injection
                var statusText = statusLabels[rawStatus] || rawStatus;
                value.textContent = statusText;
            }
            else if (field.label === this.l10n.getConstant('model')) {
                var modelValue = String(field.value);
                value.textContent = modelValue;
                value.setAttribute('title', modelValue);
            }
            else {
                value.textContent = String(field.value);
            }
            row.appendChild(label);
            row.appendChild(value);
            wrap.appendChild(row);
        }
        if (!isNullOrUndefined(report.customAttributes)) {
            var customKeys = Object.keys(report.customAttributes);
            for (var i = 0; i < customKeys.length; i++) {
                var customKey = customKeys[parseInt(i.toString(), 10)];
                // eslint-disable-next-line security/detect-object-injection
                var customValue = report.customAttributes[customKey];
                if (isNullOrUndefined(customValue)) {
                    continue;
                }
                var row = this.createElement('div', { className: 'e-assist-telemetry-row' });
                var label = this.createElement('span', { className: 'e-assist-telemetry-label' });
                label.textContent = customKey;
                var value = this.createElement('span', { className: 'e-assist-telemetry-value' });
                value.textContent = String(customValue);
                row.appendChild(label);
                row.appendChild(value);
                wrap.appendChild(row);
            }
        }
        return wrap;
    };
    /**
     * Creates the telemetry summary button displayed in the response toolbar.
     * Shows the recorded duration when available or a placeholder when no report exists.
     *
     * @param {TelemetryReport} [report] - Specifies the telemetry report used to populate the button label.
     * @returns {ToolbarItemModel} Returns the telemetry summary toolbar item configuration.
     */
    AIAssistView.prototype.buildTelemetryToolbarItem = function (report) {
        var cssClass = TELEMETRY_TOOLBAR_ITEM_CSS_CLASS;
        if (report) {
            return {
                type: 'Button',
                text: this.formatDuration(report.duration),
                cssClass: cssClass,
                align: 'Left'
            };
        }
        return {
            type: 'Button',
            text: '\u2014 ms',
            cssClass: cssClass,
            align: 'Left',
            disabled: true
        };
    };
    /**
     * Adds the telemetry summary button to the response toolbar when applicable.
     * Accepts a prompt index and telemetry report used to configure the button.
     *
     * @param {number} promptIndex - Specifies the prompt index associated with the toolbar.
     * @param {TelemetryReport} report - Specifies the telemetry report used to populate the button.
     * @returns {void}
     */
    AIAssistView.prototype.ensureTelemetryToolbarItem = function (promptIndex, report) {
        if (!this.element || !this.responseToolbarEle) {
            return;
        }
        var container = this.element.querySelector('#e-response-item_' + promptIndex + ' .e-toolbar-items, #e-response-item_' + promptIndex + ' .e-toolbar');
        if (!container) {
            return;
        }
        if (container.querySelector('.' + TELEMETRY_TOOLBAR_ITEM_CSS_CLASS)) {
            return;
        }
        var telemetryItem = this.buildTelemetryToolbarItem(report);
        var telemetryEJItem = {
            type: telemetryItem.type,
            visible: telemetryItem.visible,
            disabled: telemetryItem.disabled,
            tooltipText: telemetryItem.tooltip,
            template: telemetryItem.template,
            prefixIcon: telemetryItem.iconCss,
            text: telemetryItem.text,
            cssClass: telemetryItem.cssClass,
            align: telemetryItem.align || 'Left',
            width: this.responseToolbarSettings.width,
            tabIndex: telemetryItem.tabIndex
        };
        this.responseToolbarEle.addItems([telemetryEJItem], this.responseToolbarEle.items.length);
    };
    /**
     * Updates the telemetry button and tooltip content for a response toolbar.
     * Accepts a prompt index and telemetry report containing the latest display data.
     *
     * @param {number} promptIndex - Specifies the prompt index associated with the toolbar item.
     * @param {TelemetryReport} report - Specifies the telemetry report used to refresh the button and tooltip.
     * @returns {void}
     */
    AIAssistView.prototype.updateTelemetryToolbarItem = function (promptIndex, report) {
        var responseContainer = this.element.querySelector('#e-response-item_' + promptIndex + ' .e-toolbar-items, #e-response-item_' + promptIndex + ' .e-toolbar');
        if (!responseContainer) {
            return;
        }
        var wrapper = responseContainer.querySelector('.' + TELEMETRY_TOOLBAR_ITEM_CSS_CLASS);
        if (!wrapper) {
            return;
        }
        var btn = wrapper.querySelector('button');
        if (!btn) {
            return;
        }
        var tooltip = this.formatTelemetryTooltip(report);
        var textSpan = btn.querySelector('.e-tbar-btn-text');
        if (textSpan) {
            textSpan.textContent = this.formatDuration(report.duration);
        }
        btn.setAttribute('aria-label', 'Telemetry data');
        wrapper.classList.remove('e-overlay');
        btn.removeAttribute('aria-disabled');
        btn.removeAttribute('disabled');
        this.refreshTelemetryTooltip(promptIndex, btn, tooltip);
    };
    /**
     * Creates and attaches a tooltip to a telemetry summary button.
     * Accepts a prompt index, target button element, and tooltip content.
     *
     * @param {number} promptIndex - Specifies the prompt index associated with the tooltip.
     * @param {HTMLElement} btn - Specifies the telemetry button that hosts the tooltip.
     * @param {string | HTMLElement} content - Specifies the content displayed inside the tooltip.
     * @returns {void}
     */
    AIAssistView.prototype.attachTelemetryTooltip = function (promptIndex, btn, content) {
        var existing = this.telemetryTooltipsByPrompt.get(promptIndex);
        if (existing) {
            existing.destroy();
        }
        if (!btn.id) {
            btn.id = 'e-assist-telemetry-btn-' + promptIndex + '-' + getUniqueID('x');
        }
        var tip = new Tooltip({
            content: content,
            target: '#' + btn.id,
            position: 'RightCenter',
            opensOn: 'Hover',
            cssClass: 'e-assist-telemetry-tooltip',
            width: 'auto',
            height: 'auto'
        });
        tip.appendTo(document.body);
        this.telemetryTooltipsByPrompt.set(promptIndex, tip);
    };
    /**
     * Updates the content of an existing telemetry tooltip.
     * Accepts a prompt index, target button element, and tooltip content to display.
     *
     * @param {number} promptIndex - Specifies the prompt index associated with the tooltip.
     * @param {HTMLElement} btn - Specifies the telemetry button that hosts the tooltip.
     * @param {string | HTMLElement} content - Specifies the content displayed inside the tooltip.
     * @returns {void}
     */
    AIAssistView.prototype.refreshTelemetryTooltip = function (promptIndex, btn, content) {
        var existing = this.telemetryTooltipsByPrompt.get(promptIndex);
        if (existing) {
            existing.content = content;
            existing.dataBind();
            return;
        }
        this.attachTelemetryTooltip(promptIndex, btn, content);
    };
    /**
     * Adds telemetry buttons and tooltips to rendered responses with available reports.
     * Only responses that have cached telemetry data are updated.
     *
     * @returns {void}
     */
    AIAssistView.prototype.addTelemetryToolbarForAllResponses = function () {
        var indices = Array.from(this.telemetryReportsByPrompt.keys());
        for (var i = 0; i < indices.length; i++) {
            var promptIndex = indices[parseInt(i.toString(), 10)];
            var cached = this.telemetryReportsByPrompt.get(promptIndex);
            if (!cached) {
                continue;
            }
            this.ensureTelemetryToolbarItem(promptIndex, cached);
            this.updateTelemetryToolbarItem(promptIndex, cached);
        }
    };
    /**
     * Removes all telemetry UI elements and clears cached telemetry data.
     * Destroys associated tooltips, removes toolbar buttons, and resets telemetry state.
     *
     * @returns {void}
     */
    AIAssistView.prototype.removeTelemetryToolbarForAllResponses = function () {
        this.telemetryTooltipsByPrompt.forEach(function (tip) {
            if (!tip) {
                return;
            }
            tip.destroy();
        });
        this.telemetryTooltipsByPrompt.clear();
        this.telemetryReportsByPrompt.clear();
        var wrappers = this.element.querySelectorAll('.e-output-container[id^="e-response-item_"] .e-response-toolbar-wrapper .' +
            TELEMETRY_TOOLBAR_ITEM_CSS_CLASS);
        if (this.responseToolbarEle && typeof this.responseToolbarEle.removeItems === 'function') {
            for (var i = 0; i < wrappers.length; i++) {
                var wrapper = wrappers[parseInt(i.toString(), 10)];
                this.responseToolbarEle.removeItems(wrapper);
            }
            this.responseToolbarEle.dataBind();
        }
    };
    AIAssistView.prototype.unWireEvents = function () {
        this.unWireFooterEvents(this.footerTemplate);
        if (this.editableTextarea) {
            var footerIconsWrapper = this.footer.querySelector('.e-footer-icons-wrapper');
            if (footerIconsWrapper) {
                this.removeFooterIconHandlersFrom(footerIconsWrapper);
            }
            var footerLeftItems = this.footer.querySelector('.e-footer-left-items');
            if (footerLeftItems) {
                this.removeFooterIconHandlersFrom(footerLeftItems);
            }
        }
        this.detachCodeCopyEventHandler();
        this.unBindScroll();
    };
    AIAssistView.prototype.onFocusEditableTextarea = function () {
        if (this.footer) {
            this.footer.classList.add('e-footer-focused');
        }
        this.toggleClearIcon();
    };
    AIAssistView.prototype.onBlurEditableTextarea = function (e) {
        var relatedTargetEle = e.relatedTarget;
        if (relatedTargetEle && relatedTargetEle.closest('.e-toolbar')) {
            return;
        }
        if (!relatedTargetEle) {
            if (this.footer) {
                this.footer.classList.remove('e-footer-focused');
            }
            if (this.clearToolbarItem) {
                this.toggleClearIcon();
            }
        }
        else {
            if (this.clearToolbarItem) {
                if (relatedTargetEle && !(relatedTargetEle.querySelector('.e-assist-clear-icon'))) {
                    this.toggleClearIcon();
                }
            }
            if (this.footer) {
                this.footer.classList.remove('e-footer-focused');
            }
        }
    };
    AIAssistView.prototype.detachCodeCopyEventHandler = function () {
        this.preTagElements.forEach(function (_a) {
            var preTag = _a.preTag, handler = _a.handler;
            var copyIcon = preTag.querySelector('.e-code-copy');
            EventHandler.remove(copyIcon, 'click', handler);
        });
        this.preTagElements = [];
    };
    AIAssistView.prototype.keyHandler = function (event, value) {
        if (event.key === 'Enter' && !event.shiftKey) {
            var mentionPopup = document.querySelector('.e-assist-mention.e-mention');
            if (mentionPopup && mentionPopup.classList.contains('e-popup-open')) {
                return;
            }
            switch (value) {
                case 'footer':
                    this.pushToUndoStack(this.editableTextarea.innerText);
                    event.preventDefault();
                    if (!this.isResponseRequested) {
                        this.onSendIconClick();
                    }
                    else if (this.isResponseRequested && this.hasStopResponseButton()) {
                        this.respondingStopper(event);
                    }
                    break;
            }
        }
        else if (event.key === 'Backspace' || event.key === 'Delete') {
            if (this.speechToTextObj) {
                this.speechToTextObj.transcript = '';
            }
        }
        else {
            this.handleUndoRedo(event);
        }
    };
    AIAssistView.prototype.clearIconHandler = function () {
        var prevOnChange = this.isProtectedOnChange;
        this.isProtectedOnChange = true;
        this.editableTextarea.innerText = this.prompt = '';
        if (this.speechToTextObj) {
            this.speechToTextObj.transcript = '';
        }
        this.isProtectedOnChange = prevOnChange;
        this.refreshTextareaUI();
        this.editableTextarea.focus();
        this.pushToUndoStack(this.prompt);
        this.checkAndActivateSendIcon();
    };
    AIAssistView.prototype.respondingStopper = function (event) {
        // Finalize incomplete thinking blocks to error state before stopping output
        var prevOnChange = this.isProtectedOnChange;
        this.isProtectedOnChange = true;
        this.finalizeIncompleteThinkingBlocks();
        this.isProtectedOnChange = prevOnChange;
        // Emit cancel telemetry before resetting UI.
        this.emitTelemetryReport('cancelled');
        this.isOutputRenderingStop = true;
        this.isResponseRequested = false;
        this.lastStreamPrompt = '';
        if (this.outputElement.hasChildNodes) {
            if (this.skeletonContainer && (this.skeletonContainer.parentNode === this.outputElement)) {
                this.outputElement.removeChild(this.skeletonContainer);
            }
        }
        this.toggleStopRespondingButton(false);
        var promptIndex = this.prompts ? this.prompts.length - 1 : -1;
        var eventArgs = {
            event: event,
            prompt: promptIndex >= 0 ? this.prompts[parseInt(promptIndex.toString(), 10)].prompt : '',
            dataIndex: this.prompts ? this.prompts.length - 1 : -1
        };
        this.trigger('stopRespondingClick', eventArgs);
        var outputContainer = this.element.querySelector("#e-response-item_" + promptIndex);
        if (outputContainer) {
            var outputContentBodyEle = this.element.querySelector("#e-response-item_" + (this.prompts.length - 1)).querySelector('.e-content-body');
            if (outputContentBodyEle) {
                this.renderPreTag(outputContentBodyEle);
            }
        }
    };
    AIAssistView.prototype.onSuggestionClick = function (e, suggestion) {
        this.suggestionsElement.hidden = true;
        var prevOnChange = this.isProtectedOnChange;
        this.isProtectedOnChange = true;
        // Prefer the passed-in canonical suggestion; fall back to event target text if absent
        this.prompt = !isNOU(suggestion) ? suggestion : e.target.innerText;
        this.isProtectedOnChange = prevOnChange;
        this.onSendIconClick();
    };
    AIAssistView.prototype.onSendIconClick = function () {
        if (this.isResponseRequested || !(this.prompt.trim() || this.uploadedFiles.length)) {
            return;
        }
        if (!isNOU(this.speechToTextObj)) {
            this.speechToTextObj.stopListening();
        }
        this.isResponseRequested = true;
        this.lastStreamPrompt = '';
        // Telemetry — start of a new turn
        this.resetActiveTurn();
        this.activeTurnStartTs = performance.now();
        if (this.suggestionsElement) {
            this.suggestionsElement.hidden = true;
        }
        this.isOutputRenderingStop = false;
        this.toggleStopRespondingButton(true);
        this.addPrompt();
        if (this.prompts.length === 1) {
            this.updateBannerTemplate('');
        }
        this.createOutputElement();
        var mentionChips = this.getMentionItems();
        var eventArgs = {
            cancel: false,
            responseToolbarItems: this.responseToolbarSettings.items,
            prompt: this.prompt,
            promptSuggestions: this.promptSuggestions,
            attachedFiles: this.uploadedFiles.slice(),
            mentions: mentionChips
        };
        this.clearUploadedFiles();
        this.selectedMentions = [];
        this.mentionCounter = 0;
        if (!this.footerTemplate) {
            var prevOnChange = this.isProtectedOnChange;
            this.isProtectedOnChange = true;
            this.prompt = this.editableTextarea.innerText = '';
            this.isProtectedOnChange = prevOnChange;
            this.refreshTextareaUI();
            this.pushToUndoStack(this.prompt);
        }
        this.setupViewportFilling();
        this.trigger('promptRequest', eventArgs);
        if (this.contentWrapper) {
            this.scrollToBottom();
        }
    };
    AIAssistView.prototype.clearUploadedFiles = function () {
        this.uploadedFiles = [];
        if (this.dropArea) {
            this.dropArea.innerHTML = '';
        }
    };
    AIAssistView.prototype.getMentionItems = function () {
        var mentions = [];
        if (!this.editableTextarea || this.mentions.length === 0) {
            return mentions;
        }
        // Remove deleted mentions
        var currentEditorChips = this.editableTextarea.querySelectorAll('.e-mention-chip');
        var _loop_1 = function (i) {
            var mentionElement = currentEditorChips[parseInt(i.toString(), 10)];
            var mention = this_1.selectedMentions.find(function (item) { return item.element.getAttribute('data-mention-id') === mentionElement.getAttribute('data-mention-id'); });
            if (mention) {
                mentions.push({ itemData: mention.itemData, mentionChar: mention.mentionChar });
            }
        };
        var this_1 = this;
        for (var i = 0; i < currentEditorChips.length; i++) {
            _loop_1(i);
        }
        return mentions;
    };
    AIAssistView.prototype.getPromptText = function (promptText, promptIndex, isCopyAction) {
        var mentions = [];
        if (this.prompts[parseInt(promptIndex.toString(), 10)].mentions &&
            this.prompts[parseInt(promptIndex.toString(), 10)].mentions.length > 0) {
            mentions = this.prompts[parseInt(promptIndex.toString(), 10)].mentions;
        }
        if (!mentions || mentions.length === 0) {
            return SanitizeHtmlHelper.sanitize(promptText);
        }
        var placeholderRegex = /\{(-?\d+)\}/g;
        var renderedText = this.prompts[parseInt(promptIndex.toString(), 10)].prompt || promptText;
        var match = placeholderRegex.exec(renderedText);
        var placeholders = [];
        while (match !== null) {
            placeholders.push({
                fullMatch: match[0],
                index: parseInt(match[1], 10)
            });
            match = placeholderRegex.exec(renderedText);
        }
        for (var _i = 0, placeholders_1 = placeholders; _i < placeholders_1.length; _i++) {
            var placeholder = placeholders_1[_i];
            var mentionIndex = placeholder.index;
            if (mentionIndex >= 0 && mentionIndex < mentions.length) {
                var mention = mentions[parseInt(mentionIndex.toString(), 10)];
                if (mention) {
                    renderedText = renderedText.replace(placeholder.fullMatch, this.renderMentionChipSimple(mention, isCopyAction));
                }
            }
        }
        return SanitizeHtmlHelper.sanitize(renderedText);
    };
    AIAssistView.prototype.renderMentionChipSimple = function (mention, isCopyAction) {
        var settings = this.mentions.find(function (m) { return m.mentionChar === mention.mentionChar; });
        if (isNOU(settings) || !mention.itemData) {
            return '';
        }
        var textFieldName = settings.fields.text;
        // eslint-disable-next-line security/detect-object-injection
        var textValue = mention.itemData[textFieldName] || mention.itemData.text;
        var textContent = !isNOU(textValue) ? String(textValue) : '';
        if (isCopyAction) {
            return SanitizeHtmlHelper.sanitize(textContent);
        }
        var displayTemplate = settings.displayTemplate;
        if (!isNOU(displayTemplate) && !(typeof displayTemplate === 'string' && displayTemplate === '')) {
            var tempContainer = this.createElement('div');
            this.updateContent(displayTemplate, tempContainer, mention.itemData, 'mentionDisplayTemplate');
            var mentionContent = tempContainer.innerHTML;
            // Interpolate ${field} placeholders with data values
            for (var key in mention.itemData) {
                if (Object.prototype.hasOwnProperty.call(mention.itemData, key)) {
                    // eslint-disable-next-line security/detect-object-injection
                    var value = mention.itemData[key];
                    var escapeKey = key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                    var pattern = '\\$\\{' + escapeKey + '\\}';
                    // eslint-disable-next-line security/detect-non-literal-regexp
                    mentionContent = mentionContent.replace(new RegExp(pattern, 'g'), !isNOU(value) ? String(value) : '');
                }
            }
            return '<span class="e-mention-chip">' + SanitizeHtmlHelper.sanitize(mentionContent) + '</span>';
        }
        var mentionElement = '<span class="e-mention-chip">' +
            this.getMentionElement(settings, mention.itemData) +
            '</span>';
        return SanitizeHtmlHelper.sanitize(mentionElement);
    };
    AIAssistView.prototype.getPromptTextWithPlaceholders = function () {
        if (!this.editableTextarea) {
            return this.prompt;
        }
        var contentClone = this.editableTextarea.cloneNode(true);
        var placeholderIndex = 0;
        var mentionElements = contentClone.querySelectorAll('.e-mention-chip');
        for (var _i = 0, _a = Array.from(mentionElements); _i < _a.length; _i++) {
            var mentionElement = _a[_i];
            var placeholder = document.createTextNode("{" + placeholderIndex + "}");
            mentionElement.replaceWith(placeholder);
            placeholderIndex++;
        }
        return SanitizeHtmlHelper.sanitize(contentClone.innerHTML);
    };
    AIAssistView.prototype.addPrompt = function () {
        var prevOnChange = this.isProtectedOnChange;
        this.isProtectedOnChange = true;
        var mentionChips = this.getMentionItems();
        var promptTextWithPlaceholders = mentionChips.length > 0 ? this.getPromptTextWithPlaceholders() : this.prompt;
        this.prompts = this.prompts.concat([{ prompt: promptTextWithPlaceholders, response: '', isResponseHelpful: null, attachedFiles: this.uploadedFiles, blocks: null, mentions: mentionChips }]);
        this.isProtectedOnChange = prevOnChange;
    };
    AIAssistView.prototype.getContextObject = function (templateName, contentElement, index, arrayPosition, file) {
        var template;
        var context = {};
        var contextIndex = index >= 0 ? index : -1;
        var contextPrompt = index >= 0 ? this.prompts[parseInt(contextIndex.toString(), 10)].prompt : '';
        var contextOutput = index >= 0 ? this.prompts[parseInt(contextIndex.toString(), 10)].response : '';
        switch (templateName.toLowerCase()) {
            case 'promptitemtemplate': {
                template = this.promptItemTemplate;
                context = {
                    prompt: contextPrompt,
                    toolbarItems: this.promptToolbarSettings.items,
                    index: contextIndex,
                    attachedFiles: this.uploadedFiles,
                    mentions: index >= 0 ? this.prompts[parseInt(contextIndex.toString(), 10)].mentions : null
                };
                break;
            }
            case 'responseitemtemplate': {
                template = this.responseItemTemplate;
                context = {
                    prompt: contextPrompt,
                    response: contextOutput,
                    index: contextIndex,
                    toolbarItems: this.responseToolbarSettings.items,
                    blocks: index >= 0 ? this.prompts[parseInt(contextIndex.toString(), 10)].blocks : null
                };
                break;
            }
            case 'customviewtemplate':
            case 'assistviewtemplate': {
                template = this.views[parseInt(arrayPosition.toString(), 10)].viewTemplate || '';
                break;
            }
            case 'attachmenttemplate': {
                template = this.attachmentSettings.attachmentTemplate;
                context = { selectedFile: file };
                break;
            }
        }
        this.updateContent(template, contentElement, context, templateName);
    };
    AIAssistView.prototype.createOutputElement = function () {
        this.outputSuggestionEle = this.createElement('div', { attrs: { id: "e-prompt-item_" + (this.prompts.length - 1), class: "e-prompt-container " + (this.promptItemTemplate ? 'e-prompt-item-template' : '') } });
        this.renderPrompt(this.prompt, this.prompts.length - 1, this.uploadedFiles);
        this.outputElement.append(this.outputSuggestionEle, this.skeletonContainer);
        this.skeletonContainer.hidden = false;
    };
    AIAssistView.prototype.renderOutputContainer = function (promptText, outputText, attachedFiles, index, isMethodCall, isFinalUpdate, blocks) {
        var outputContainer = this.createElement('div', { attrs: __assign({ id: "e-response-item_" + index, class: "e-output-container " + (this.responseItemTemplate ? 'e-response-item-template' : '') }, (this.latestResponseMinHeight != null ?
                { style: "min-height:" + this.latestResponseMinHeight + "px" } : {})) });
        this.renderOutput(outputContainer, promptText, outputText, attachedFiles, isMethodCall, index, isFinalUpdate, blocks);
        if (promptText) {
            this.outputElement.append(this.outputSuggestionEle);
        }
        this.outputElement.append(outputContainer);
        if (this.hasStopResponseButton() && isFinalUpdate && !this.isToolResponse) {
            this.toggleStopRespondingButton(false);
        }
        if (!this.isOutputRenderingStop && !this.content.contains(this.suggestionsElement) && this.suggestionsElement) {
            this.content.append(this.suggestionsElement);
        }
    };
    AIAssistView.prototype.requiredModules = function () {
        var modules = [];
        modules.push({ member: 'assistThinking', args: [this] });
        return modules;
    };
    AIAssistView.prototype.renderOutput = function (outputContainer, promptText, outputText, attachedFiles, isMethodCall, index, isFinalUpdate, blocks) {
        var promptIcon = this.createElement('span', {
            className: 'e-output-icon e-icons ' + (this.responseIconCss || (this.isAssistView && this.views[0].iconCss) || 'e-assistview-icon')
        });
        var aiOutputEle = this.createElement('div', { className: 'e-output' });
        if (!this.aiAssistViewRendered || isMethodCall) {
            if (!isNOU(promptText) || (attachedFiles && attachedFiles.length > 0)) {
                this.outputSuggestionEle = this.createElement('div', { attrs: { id: "e-prompt-item_" + index, class: "e-prompt-container " + (this.promptItemTemplate ? 'e-prompt-item-template' : '') } });
                this.renderPrompt(promptText, index, attachedFiles);
            }
        }
        var lastPrompt = { prompt: promptText, response: outputText, blocks: blocks };
        var hasToolBlocks = Array.isArray(lastPrompt.blocks) && lastPrompt.blocks.length > 0;
        if (lastPrompt.response || hasToolBlocks) {
            if (this.responseItemTemplate) {
                this.getContextObject('responseItemTemplate', aiOutputEle, index);
                if (this.hasSkeletonEle() || this.outputElement.querySelector('.e-skeleton')) {
                    this.outputElement.removeChild(this.skeletonContainer);
                }
                if (this.contentFooterEle) {
                    this.contentFooterEle.classList.remove('e-assist-toolbar-active');
                }
                if (isFinalUpdate && this.hasStopResponseButton()) {
                    this.toggleStopRespondingButton(false);
                }
                this.renderOutputToolbarItems(index, isFinalUpdate);
                aiOutputEle.append(this.contentFooterEle);
                outputContainer.append(aiOutputEle);
            }
            else {
                this.renderOutputTextContainer(lastPrompt.response, aiOutputEle, index, false, isFinalUpdate, lastPrompt.blocks);
                outputContainer.append(promptIcon, aiOutputEle);
            }
        }
        else if (this.aiAssistViewRendered) {
            if (this.outputElement.querySelector('.e-skeleton')) {
                this.outputElement.removeChild(this.skeletonContainer);
            }
            if (this.suggestionsElement) {
                this.suggestionsElement.hidden = false;
            }
        }
    };
    AIAssistView.prototype.renderResponseSegments = function (outputEle, blocks, isFinalUpdate) {
        if (blocks.length === 0) {
            return;
        }
        if (!this.lastRenderedBlockCount) {
            this.lastRenderedBlockCount = 0;
        }
        if (blocks.length > this.lastRenderedBlockCount) {
            // NEW BLOCKS: Update already-rendered blocks state, then render new blocks
            this.updateExistingBlocksState(blocks, this.lastRenderedBlockCount);
            this.blockIndex = this.lastRenderedBlockCount;
            this.renderNextSegment(outputEle, blocks, isFinalUpdate);
            this.lastRenderedBlockCount = blocks.length;
        }
        else if (blocks.length === this.lastRenderedBlockCount) {
            // SAME COUNT: Update state of all already-rendered blocks
            this.updateExistingBlocksState(blocks, this.lastRenderedBlockCount);
            if (blocks[this.lastRenderedBlockCount - 1].blockType === 'text') {
                var block = blocks[this.lastRenderedBlockCount - 1];
                var responseItem = this.element.querySelector("#e-response-item_" + (this.prompts.length - 1));
                this.updateResponse('', this.prompts.length - 1, isFinalUpdate, responseItem, block);
            }
            this.updateLastThinkingBlock(blocks);
        }
        if (isFinalUpdate) {
            if (this.blockIndex >= blocks.length && this.hasStopResponseButton()) {
                this.toggleStopRespondingButton(false);
                this.isResponseRequested = false;
            }
        }
    };
    AIAssistView.prototype.updateExistingBlocksState = function (blocks, renderedCount) {
        var responseItem = this.element.querySelector("#e-response-item_" + (this.prompts.length - 1));
        if (responseItem) {
            // Check and update only the blocks that were already rendered (0 to renderedCount-1)
            for (var index = 0; index < renderedCount; index++) {
                var block = blocks[parseInt(index.toString(), 10)];
                // Only thinking blocks have state that can change (isActive, stages status)
                if (block.blockType === 'thinking') {
                    var thinkingBlock = block;
                    var blockWrapper = responseItem.querySelector(".e-response-block-item-" + index);
                    if (blockWrapper) {
                        // Update isActive state (spinner/check icon)
                        var isActiveChanged = thinkingBlock.isActive !== (blockWrapper.classList.contains('e-thinking-active'));
                        if (isActiveChanged) {
                            if (thinkingBlock.isActive) {
                                // Block becoming active: replace check icon with spinner
                                blockWrapper.classList.add('e-thinking-active');
                                blockWrapper.classList.remove('e-thinking-finished');
                                // Find the check icon span and replace with spinner span
                                var headerButton = blockWrapper.querySelector('.e-aiassist-thinking-toggle');
                                if (headerButton) {
                                    var checkIconSpan = headerButton.querySelector('.e-icons.e-check');
                                    if (checkIconSpan) {
                                        // Create new spinner span
                                        var spinnerSpan = this.createElement('span', {
                                            attrs: { class: 'e-active-spinner' }
                                        });
                                        // Create and show spinner
                                        createSpinner({ target: spinnerSpan, type: 'Bootstrap' });
                                        // Replace check icon with spinner
                                        checkIconSpan.replaceWith(spinnerSpan);
                                        showSpinner(spinnerSpan);
                                    }
                                }
                            }
                            else {
                                // Block becoming inactive: replace spinner with check icon
                                blockWrapper.classList.remove('e-thinking-active');
                                blockWrapper.classList.add('e-thinking-finished');
                                // Find the spinner span and replace with check icon span
                                var headerButton = blockWrapper.querySelector('.e-aiassist-thinking-toggle');
                                if (headerButton) {
                                    var spinnerSpan = headerButton.querySelector('.e-active-spinner');
                                    if (spinnerSpan) {
                                        // Hide and destroy spinner
                                        hideSpinner(spinnerSpan);
                                        // Create new check icon span
                                        var checkIconSpan = this.createElement('span', {
                                            attrs: { class: 'e-icons e-check' }
                                        });
                                        // Replace spinner with check icon
                                        spinnerSpan.replaceWith(checkIconSpan);
                                    }
                                }
                            }
                        }
                        // Update stages if they changed
                        if (thinkingBlock.stages && thinkingBlock.stages.length > 0) {
                            // Determine if this is single stage or timeline rendering
                            var isSingleStage = thinkingBlock.stages.length === 1;
                            if (isSingleStage) {
                                // Single stage rendering uses .e-single-stage-container
                                var stage = thinkingBlock.stages[0];
                                var stageElement = blockWrapper.querySelector('.e-single-stage-container');
                                if (stageElement) {
                                    // Get current stage status from DOM
                                    var statusMatch = stageElement.className.match(/e-stage-(\w+)/);
                                    var currentStatus = statusMatch ? statusMatch[1] : '';
                                    var statusChanged = stage.status !== currentStatus;
                                    if (statusChanged) {
                                        // Update stage status class (replace old status with new)
                                        stageElement.className = stageElement.className.replace(/e-stage-\w+/g, "e-stage-" + stage.status);
                                        // Update stage status icon when status changes
                                        var stageIconElement = stageElement.querySelector('.e-stage-icon');
                                        if (stageIconElement && stage.iconCss) {
                                            // Replace all icon classes with new one
                                            var iconClassList = stageIconElement.className.split(' ').filter(function (c) {
                                                return !c.includes('e-') || c === 'e-icons' || c === 'e-stage-icon';
                                            });
                                            stageIconElement.className = (iconClassList.join(' ') + " " + stage.iconCss).trim();
                                        }
                                        // Add visual indicator when transitioning to completed
                                        if (stage.status === 'completed') {
                                            stageElement.classList.add('e-stage-completed');
                                            // Hide any spinners in this stage
                                            var stageSpinners = stageElement.querySelectorAll('.e-active-spinner');
                                            stageSpinners.forEach(function (spinner) {
                                                hideSpinner(spinner);
                                            });
                                        }
                                        // Remove completed indicator and show spinners if status reverts to inprogress
                                        else if (stage.status === 'inprogress') {
                                            stageElement.classList.remove('e-stage-completed');
                                            // Show spinners when transitioning back to inprogress
                                            var stageSpinners = stageElement.querySelectorAll('.e-active-spinner');
                                            stageSpinners.forEach(function (spinner) {
                                                spinner.style.display = ''; // Restore display
                                                showSpinner(spinner);
                                            });
                                        }
                                    }
                                }
                            }
                            else {
                                // Multiple stages: Timeline rendering uses .e-timeline-wrapper with Timeline component
                                var timelineWrapper = blockWrapper.querySelector('.e-timeline-wrapper');
                                if (timelineWrapper) {
                                    // Query timeline item elements and update their states
                                    var timelineItems = timelineWrapper.querySelectorAll('.e-timeline-item');
                                    for (var stageIndex = 0; stageIndex < thinkingBlock.stages.length; stageIndex++) {
                                        var stage = thinkingBlock.stages[parseInt(stageIndex.toString(), 10)];
                                        var timelineItem = timelineItems[parseInt(stageIndex.toString(), 10)];
                                        if (timelineItem) {
                                            // Get current stage status from DOM
                                            var statusMatch = timelineItem.className.match(/e-stage-(\w+)/);
                                            var currentStatus = statusMatch ? statusMatch[1] : '';
                                            var statusChanged = stage.status !== currentStatus;
                                            if (statusChanged) {
                                                // Update timeline item status class (replace old status with new)
                                                timelineItem.className = timelineItem.className.replace(/e-stage-\w+/g, "e-stage-" + stage.status);
                                                // Update stage status icon when status changes
                                                var dotElement = timelineItem.querySelector('.e-timeline-dot');
                                                if (dotElement && stage.iconCss) {
                                                    // Update dot CSS (for status icon)
                                                    dotElement.className = "e-timeline-dot " + stage.iconCss;
                                                }
                                                // Add visual indicator when transitioning to completed
                                                if (stage.status === 'completed') {
                                                    timelineItem.classList.add('e-stage-completed');
                                                    // Hide any spinners in this timeline item
                                                    var stageSpinners = timelineItem.querySelectorAll('.e-stage-spinner');
                                                    stageSpinners.forEach(function (spinner) {
                                                        hideSpinner(spinner);
                                                    });
                                                }
                                                // Remove completed indicator and show spinners if status reverts to inprogress
                                                else if (stage.status === 'inprogress') {
                                                    timelineItem.classList.remove('e-stage-completed');
                                                    // Show spinners when transitioning back to inprogress
                                                    var stageSpinners = timelineItem.querySelectorAll('.e-stage-spinner');
                                                    stageSpinners.forEach(function (spinner) {
                                                        spinner.style.display = ''; // Restore display
                                                        showSpinner(spinner);
                                                    });
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    };
    AIAssistView.prototype.updateLastThinkingBlock = function (blocks) {
        var responseItem = this.element.querySelector("#e-response-item_" + (this.prompts.length - 1));
        if (responseItem) {
            for (var index = 0; index < blocks.length; index++) {
                if (blocks[parseInt(index.toString(), 10)].blockType === 'thinking') {
                    var thinkingBlock = blocks[parseInt(index.toString(), 10)];
                    var existingThinkingWrapper = responseItem.querySelector('.e-response-block-item-' + (index));
                    if (existingThinkingWrapper) {
                        // Clear spinnerInstances Map for this block
                        var oldSpinners = existingThinkingWrapper.querySelectorAll('.e-active-spinner');
                        oldSpinners.forEach(function (spinner) {
                            hideSpinner(spinner);
                        });
                        // Clear existing thinking content and re-render with new block data
                        existingThinkingWrapper.innerHTML = '';
                    }
                    else {
                        var outputContentBodyEle = responseItem.querySelector('.e-content-body');
                        existingThinkingWrapper = this.createElement('div', { attrs: { class: "e-response e-response-block-item-" + index } });
                        outputContentBodyEle.append(existingThinkingWrapper);
                    }
                    this.assistThinkingModule.createThinkingWrapper(thinkingBlock, existingThinkingWrapper, this.lastRenderedBlockCount - 1);
                }
            }
        }
    };
    AIAssistView.prototype.renderNextSegment = function (outputEle, blocks, isFinalUpdate) {
        var _this = this;
        if (this.blockIndex >= blocks.length) {
            if (this.enableStreaming) {
                isFinalUpdate = true;
            }
            if (isFinalUpdate) {
                if (this.hasStopResponseButton()) {
                    this.toggleStopRespondingButton(false);
                }
                var responseIndex = this.prompts.length - 1;
                var responseItem = this.element.querySelector('#e-response-item_' + (responseIndex));
                if (!this.responseItemTemplate && responseItem) {
                    var outputContainer = responseItem.querySelector('.e-output');
                    if (isFinalUpdate && this.suggestionsElement) {
                        this.suggestionsElement.hidden = false;
                    }
                    if (isFinalUpdate && outputContainer.querySelector('.e-content-footer') === null) {
                        this.renderOutputToolbarItems(responseIndex, isFinalUpdate);
                        this.appendChildren(outputContainer, this.contentFooterEle);
                    }
                }
                this.isResponseRequested = false;
            }
            return;
        }
        var responseBlock = blocks[parseInt(this.blockIndex.toString(), 10)];
        var responseWrapper = this.createElement('div', { attrs: { class: "e-response e-response-block-item-" + this.blockIndex } });
        this.blockIndex++;
        // TEXT SEGMENT
        if (responseBlock.blockType === 'text') {
            var responseText_1 = this.createElement('div', {
                attrs: { class: 'e-text' }
            });
            responseWrapper.append(responseText_1);
            outputEle.appendChild(responseWrapper);
            var htmlResponse = MarkdownConverter.toHtml(responseBlock.content);
            if (this.enableStreaming && !isFinalUpdate) {
                this.streamToolResponse(htmlResponse, responseText_1, function () {
                    if (isFinalUpdate) {
                        _this.renderPreTag(responseText_1);
                    }
                    _this.renderNextSegment(outputEle, blocks, isFinalUpdate);
                });
            }
            else {
                responseText_1.innerHTML = htmlResponse;
                this.renderNextSegment(outputEle, blocks, isFinalUpdate);
            }
            return;
        }
        // TOOL SEGMENT
        if (responseBlock.blockType === 'tool') {
            var tool = this.registeredTools.get(responseBlock.toolName.toLowerCase());
            if (tool) {
                var toolContainer = this.createElement('div', {
                    attrs: {
                        class: 'e-assist-tool'
                    }
                });
                responseWrapper.append(toolContainer);
                outputEle.appendChild(responseWrapper);
                this.renderToolUI(responseBlock, tool, toolContainer);
            }
            this.renderNextSegment(outputEle, blocks, isFinalUpdate);
            return;
        }
        //Thinking SEGMENT
        if (responseBlock.blockType === 'thinking') {
            this.assistThinkingModule.createThinkingWrapper(responseBlock, responseWrapper, this.blockIndex - 1);
            outputEle.appendChild(responseWrapper);
            this.renderNextSegment(outputEle, blocks, isFinalUpdate);
            return;
        }
    };
    AIAssistView.prototype.renderToolUI = function (toolBlock, tool, container) {
        var toolArgs = toolBlock.props || {};
        try {
            this.updateContent(tool.template, container, toolArgs, 'toolTemplate');
            if (tool.handler) {
                tool.handler(container, toolArgs);
            }
        }
        catch (error) {
            //error statement
        }
    };
    AIAssistView.prototype.renderOutputTextContainer = function (response, aiOutputEle, index, isMethodCall, isFinalUpdate, blocks) {
        if (this.contentFooterEle) {
            this.contentFooterEle.classList.remove('e-assist-toolbar-active');
        }
        this.outputContentBodyEle = this.createElement('div', { attrs: { class: 'e-content-body', tabindex: '0' } });
        if (!isMethodCall && blocks && blocks.length > 0) {
            this.lastRenderedBlockCount = 0;
            this.renderResponseSegments(this.outputContentBodyEle, blocks, isFinalUpdate);
        }
        if (!isMethodCall && !isNOU(response) && response !== '') {
            this.updateDynamicResponse(this.outputContentBodyEle, isFinalUpdate, response, isNOU(blocks) ? 0 : blocks.length);
        }
        if (this.hasSkeletonEle() || this.outputElement.querySelector('.e-skeleton')) {
            this.outputElement.removeChild(this.skeletonContainer);
        }
        this.appendChildren(aiOutputEle, this.outputContentBodyEle);
        if (isFinalUpdate) {
            this.renderOutputToolbarItems(index, isFinalUpdate);
            this.appendChildren(aiOutputEle, this.contentFooterEle);
        }
    };
    AIAssistView.prototype.updateDynamicResponse = function (outputContentBodyEle, isFinalUpdate, response, blocksLength) {
        // Method used for updating the response value from prompt collection
        var responseWrapper = outputContentBodyEle.querySelector(".e-response.e-response-block-item-" + blocksLength);
        var existingResponseWrapper = responseWrapper === null;
        if (existingResponseWrapper) {
            responseWrapper = this.createElement('div', { attrs: { class: "e-response e-response-block-item-" + blocksLength } });
        }
        if (!this.enableStreaming || isFinalUpdate) {
            var htmlResponse = MarkdownConverter.toHtml(response);
            responseWrapper.innerHTML = htmlResponse;
        }
        else {
            responseWrapper.innerHTML = response;
        }
        if (isFinalUpdate) {
            this.renderPreTag(responseWrapper);
        }
        if (existingResponseWrapper) {
            outputContentBodyEle.append(responseWrapper);
        }
    };
    AIAssistView.prototype.renderPreTag = function (outputContentEle) {
        var _this = this;
        var preTags = Array.from(outputContentEle.querySelectorAll('pre'));
        preTags.forEach(function (preTag) {
            var copyIcon = document.createElement('span');
            copyIcon.className = 'e-icons e-code-copy e-assist-copy';
            preTag.insertBefore(copyIcon, preTag.firstChild);
            _this.preTagElements.push({ preTag: preTag, handler: _this.getCopyHandler(preTag) });
            EventHandler.add(copyIcon, 'click', _this.preTagElements[_this.preTagElements.length - 1].handler);
        });
    };
    AIAssistView.prototype.getCopyHandler = function (preTag) {
        return function () {
            var preText = preTag.innerText;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            if (window.navigator.clipboard && typeof window.navigator.clipboard.writeText === 'function') {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                window.navigator.clipboard.writeText(preText);
            }
            var copyIcon = preTag.querySelector('.e-code-copy');
            copyIcon.className = 'e-icons e-code-copy e-assist-check';
            setTimeout(function () {
                copyIcon.className = 'e-icons e-code-copy e-assist-copy';
            }, 1000);
        };
    };
    AIAssistView.prototype.renderOutputToolbarItems = function (index, isFinalUpdate) {
        this.contentFooterEle = this.createElement('div', {
            className: 'e-content-footer e-assist-toolbar-active'
        });
        if (this.aiAssistViewRendered) {
            if (this.outputElement.querySelector('.e-skeleton')) {
                this.outputElement.removeChild(this.skeletonContainer);
            }
            if (isFinalUpdate && this.suggestionsElement) {
                this.suggestionsElement.hidden = false;
            }
        }
        var navigationUI = this.renderResponseNavigation(index);
        if (navigationUI) {
            this.contentFooterEle.appendChild(navigationUI);
        }
        this.renderResponseToolbar(index);
        var toolbarContainer = this.createElement('div', {
            attrs: { class: 'e-response-toolbar-wrapper' }
        });
        this.responseToolbarEle.appendTo(toolbarContainer);
        this.responseToolbarEle.element.setAttribute('aria-label', "response-toolbar-" + index);
        this.contentFooterEle.appendChild(toolbarContainer);
        if (this.telemetrySettings && this.telemetrySettings.enable === true) {
            var promptIndex = parseInt((index || 0).toString(), 10);
            var cached = this.telemetryReportsByPrompt.get(promptIndex);
            var wrapper = toolbarContainer.querySelector('.' + TELEMETRY_TOOLBAR_ITEM_CSS_CLASS);
            var btn = wrapper ? wrapper.querySelector('button') : null;
            if (btn) {
                var content = cached
                    ? this.formatTelemetryTooltip(cached)
                    : 'Telemetry: awaiting first response.';
                this.attachTelemetryTooltip(promptIndex, btn, content);
            }
        }
    };
    AIAssistView.prototype.renderResponseNavigation = function (promptIndex) {
        var _this = this;
        var regeneratedResponses = this.regeneratedResponses.get(promptIndex);
        if (!regeneratedResponses || regeneratedResponses.length <= 1) {
            return this.createElement('div', {});
        }
        var navigationContainer = this.createElement('div', {
            attrs: { class: 'e-response-navigation-container' }
        });
        var currentIndex = this.currentRegeneratedIndex.get(promptIndex) || 0;
        var totalCount = regeneratedResponses.length;
        var prevButtonAttrs = {
            class: 'e-btn e-icons e-assist-previous',
            'aria-label': this.l10n.getConstant('previousResponse'),
            title: this.l10n.getConstant('previousResponse')
        };
        if (currentIndex === 0) {
            prevButtonAttrs['class'] += ' e-disabled';
        }
        var prevButton = this.createElement('button', { attrs: prevButtonAttrs });
        var indexIndicator = this.createElement('span', {
            attrs: { class: 'e-response-index-indicator' },
            innerHTML: currentIndex + 1 + " / " + totalCount
        });
        var nextButtonAttrs = {
            class: 'e-btn e-icons e-assist-next',
            'aria-label': this.l10n.getConstant('nextResponse'),
            title: this.l10n.getConstant('nextResponse')
        };
        if (currentIndex === totalCount - 1) {
            nextButtonAttrs['class'] += ' e-disabled';
        }
        var nextButton = this.createElement('button', { attrs: nextButtonAttrs });
        if (prevButton.classList.contains('e-disabled')) {
            prevButton.tabIndex = -1;
        }
        else {
            prevButton.tabIndex = 0;
        }
        if (nextButton.classList.contains('e-disabled')) {
            nextButton.tabIndex = -1;
        }
        else {
            nextButton.tabIndex = 0;
        }
        navigationContainer.appendChild(prevButton);
        navigationContainer.appendChild(indexIndicator);
        navigationContainer.appendChild(nextButton);
        EventHandler.add(prevButton, 'click', function () {
            if (prevButton.classList.contains('e-disabled')) {
                return;
            }
            _this.navigateRegeneratedResponse(promptIndex, -1);
        });
        EventHandler.add(nextButton, 'click', function () {
            if (nextButton.classList.contains('e-disabled')) {
                return;
            }
            _this.navigateRegeneratedResponse(promptIndex, 1);
        });
        return navigationContainer;
    };
    AIAssistView.prototype.navigateRegeneratedResponse = function (promptIndex, direction) {
        var regeneratedResponses = this.regeneratedResponses.get(promptIndex);
        var regeneratedBlocksArr = this.regeneratedBlocks.get(promptIndex);
        var currentIndex = this.currentRegeneratedIndex.get(promptIndex) || 0;
        var newIndex = currentIndex + direction;
        if (newIndex < 0 || newIndex >= regeneratedResponses.length) {
            return;
        }
        this.currentRegeneratedIndex.set(promptIndex, newIndex);
        var prevOnChange = this.isProtectedOnChange;
        this.isProtectedOnChange = true;
        // eslint-disable-next-line security/detect-object-injection
        this.prompts[promptIndex].response = regeneratedResponses[newIndex];
        var blocksAtIndex = regeneratedBlocksArr && newIndex < regeneratedBlocksArr.length
            ? regeneratedBlocksArr[newIndex] : [];
        this.prompts[promptIndex].blocks = blocksAtIndex;
        this.isProtectedOnChange = prevOnChange;
        var responseContainer = this.element.querySelector("#e-response-item_" + promptIndex);
        if (responseContainer) {
            if (this.responseItemTemplate) {
                // For custom template: preserve footer during navigation
                var outputEle_1 = responseContainer.querySelector('.e-output');
                var footer_1 = responseContainer.querySelector('.e-content-footer');
                if (outputEle_1 && footer_1) {
                    var childrenToRemove = Array.from(outputEle_1.children).filter(function (child) { return child !== footer_1; });
                    childrenToRemove.forEach(function (child) {
                        outputEle_1.removeChild(child);
                    });
                    this.getContextObject('responseItemTemplate', outputEle_1, promptIndex);
                    outputEle_1.appendChild(footer_1);
                }
            }
            else {
                var contentBody = responseContainer.querySelector('.e-content-body');
                if (contentBody) {
                    contentBody.innerHTML = '';
                    this.lastRenderedBlockCount = 0;
                    this.blockIndex = 0;
                    if (blocksAtIndex && blocksAtIndex.length > 0) {
                        this.renderResponseSegments(contentBody, blocksAtIndex, true);
                    }
                    var responseText = regeneratedResponses[newIndex];
                    if (!isNOU(responseText) && responseText !== '') {
                        this.updateDynamicResponse(contentBody, true, responseText, blocksAtIndex ? blocksAtIndex.length : 0);
                    }
                    if ((!blocksAtIndex || blocksAtIndex.length === 0) && (isNOU(responseText) || responseText === '')) {
                        var newResponse = MarkdownConverter.toHtml(regeneratedResponses[newIndex]);
                        contentBody.innerHTML = newResponse;
                        this.renderPreTag(contentBody);
                    }
                }
            }
            var existingNav = responseContainer.querySelector('.e-response-navigation-container');
            if (existingNav) {
                this.updateNavigationUI(promptIndex, existingNav);
            }
        }
    };
    AIAssistView.prototype.updateNavigationUI = function (promptIndex, existingNav) {
        var regeneratedResponses = this.regeneratedResponses.get(promptIndex);
        var currentIndex = this.currentRegeneratedIndex.get(promptIndex) || 0;
        var totalCount = regeneratedResponses.length;
        var prevButton = existingNav.querySelector('.e-assist-previous');
        var nextButton = existingNav.querySelector('.e-assist-next');
        var indexIndicator = existingNav.querySelector('.e-response-index-indicator');
        if (prevButton) {
            if (currentIndex === 0) {
                addClass([prevButton], 'e-disabled');
                prevButton.tabIndex = -1;
            }
            else {
                removeClass([prevButton], 'e-disabled');
                prevButton.tabIndex = 0;
            }
        }
        if (nextButton) {
            if (currentIndex === totalCount - 1) {
                addClass([nextButton], 'e-disabled');
                nextButton.tabIndex = -1;
            }
            else {
                removeClass([nextButton], 'e-disabled');
                nextButton.tabIndex = 0;
            }
        }
        if (indexIndicator) {
            indexIndicator.innerHTML = currentIndex + 1 + " / " + totalCount;
        }
    };
    AIAssistView.prototype.renderResponseToolbar = function (index) {
        var _this = this;
        var pushToolbar = this.responseToolbarSettings.items.map(function (item) {
            var toolbarItem = {
                type: item.type,
                visible: item.visible,
                disabled: item.disabled,
                tooltipText: item.tooltip,
                template: item.template,
                prefixIcon: item.iconCss,
                text: item.text,
                cssClass: item.cssClass,
                align: item.align,
                width: _this.responseToolbarSettings.width,
                tabIndex: item.tabIndex
            };
            if (toolbarItem.prefixIcon === 'e-icons e-assist-like' && _this.prompts[parseInt(index.toString(), 10)].isResponseHelpful) {
                toolbarItem.prefixIcon = 'e-icons e-assist-like-filled';
            }
            else if (toolbarItem.prefixIcon === 'e-icons e-assist-dislike' && _this.prompts[parseInt(index.toString(), 10)].isResponseHelpful === false) {
                toolbarItem.prefixIcon = 'e-icons e-assist-dislike-filled';
            }
            return toolbarItem;
        });
        if (this.telemetrySettings && this.telemetrySettings.enable === true) {
            var promptIndex = parseInt((index || 0).toString(), 10);
            var cachedReport = this.telemetryReportsByPrompt.get(promptIndex);
            if (cachedReport) {
                var telemetryItem = this.buildTelemetryToolbarItem(cachedReport);
                var telemetryEJItem = {
                    type: telemetryItem.type,
                    visible: telemetryItem.visible,
                    disabled: telemetryItem.disabled,
                    tooltipText: telemetryItem.tooltip,
                    template: telemetryItem.template,
                    prefixIcon: telemetryItem.iconCss,
                    text: telemetryItem.text,
                    cssClass: telemetryItem.cssClass,
                    align: telemetryItem.align || 'Left',
                    width: this.responseToolbarSettings.width,
                    tabIndex: telemetryItem.tabIndex
                };
                pushToolbar.push(telemetryEJItem);
            }
        }
        this.responseToolbarEle = new Toolbar({
            items: pushToolbar,
            clicked: function (args) {
                var eventItemArgs = {
                    type: args.item.type,
                    text: args.item.text,
                    iconCss: args.item.prefixIcon,
                    cssClass: args.item.cssClass,
                    tooltip: args.item.tooltipText,
                    template: args.item.template,
                    disabled: args.item.disabled,
                    visible: args.item.visible,
                    align: args.item.align,
                    tabIndex: args.item.tabIndex
                };
                var eventArgs = {
                    item: eventItemArgs,
                    event: args.originalEvent,
                    cancel: false,
                    dataIndex: index
                };
                if (_this.responseToolbarSettings.itemClicked) {
                    _this.responseToolbarSettings.itemClicked.call(_this, eventArgs);
                }
                if (!eventArgs.cancel) {
                    _this.handleItemClick(args, index);
                }
            }
        });
    };
    AIAssistView.prototype.extractResponseText = function (output) {
        if (typeof output === 'string') {
            return output;
        }
        if (typeof output === 'object') {
            return output.response;
        }
        return '';
    };
    AIAssistView.prototype.handleRegenerateClick = function (promptIndex) {
        // eslint-disable-next-line security/detect-object-injection
        var currentResponse = this.prompts[promptIndex].response;
        // eslint-disable-next-line security/detect-object-injection
        var currentBlocks = this.prompts[promptIndex].blocks;
        if (!this.regeneratedResponses.has(promptIndex)) {
            this.regeneratedResponses.set(promptIndex, [currentResponse]);
            this.regeneratedBlocks.set(promptIndex, [currentBlocks || []]);
            this.currentRegeneratedIndex.set(promptIndex, 0);
        }
        this.isRegenerating = true;
        this.regeneratingPromptIndex = promptIndex;
        this.isResponseRequested = true;
        this.isOutputRenderingStop = false;
        this.toggleStopRespondingButton(true);
        this.resetResponse(promptIndex);
        // eslint-disable-next-line security/detect-object-injection
        var promptText = this.prompts[promptIndex].prompt;
        var eventArgs = {
            cancel: false,
            prompt: promptText,
            // eslint-disable-next-line security/detect-object-injection
            attachedFiles: this.prompts[promptIndex].attachedFiles || [],
            mentions: this.prompts[parseInt(promptIndex.toString(), 10)].mentions || []
        };
        this.trigger('promptRequest', eventArgs);
    };
    AIAssistView.prototype.resetResponse = function (promptIndex) {
        var responseContainer = this.element.querySelector("#e-response-item_" + promptIndex);
        var loadingIndicatorElement;
        if (this.responseAnimationTemplate) {
            loadingIndicatorElement = this.skeletonContainer;
        }
        else {
            loadingIndicatorElement = this.skeletonContainer.querySelector('.e-loading-body');
        }
        if (this.responseItemTemplate) {
            var outputEle_2 = responseContainer.querySelector('.e-output');
            var footer_2 = outputEle_2.querySelector('.e-content-footer');
            var childrenToRemove = Array.from(outputEle_2.children).filter(function (child) { return child !== footer_2; });
            childrenToRemove.forEach(function (child) {
                outputEle_2.removeChild(child);
            });
            outputEle_2.insertBefore(loadingIndicatorElement, footer_2);
            this.hideResponseToolbar(responseContainer);
        }
        else {
            var contentBody = responseContainer.querySelector('.e-content-body');
            contentBody.innerHTML = '';
            contentBody.appendChild(loadingIndicatorElement);
            this.hideResponseToolbar(responseContainer);
        }
        this.renderSkeleton();
    };
    AIAssistView.prototype.hideResponseToolbar = function (responseContainer) {
        var navigationContainer = responseContainer.querySelector('.e-response-navigation-container');
        if (navigationContainer) {
            navigationContainer.classList.add('e-response-hidden');
        }
        var toolbarWrapper = responseContainer.querySelector('.e-response-toolbar-wrapper');
        if (toolbarWrapper) {
            toolbarWrapper.classList.add('e-response-hidden');
        }
    };
    AIAssistView.prototype.handleItemClick = function (args, index) {
        var _this = this;
        if (args.item.prefixIcon === 'e-icons e-assist-copy') {
            var currentPrompt = this.prompts[parseInt(index.toString(), 10)];
            var contentToCopy = currentPrompt.response;
            if (!contentToCopy && currentPrompt.blocks && currentPrompt.blocks.length > 0) {
                var blocks = currentPrompt.blocks;
                for (var i = blocks.length - 1; i >= 0; i--) {
                    if (blocks[parseInt(i.toString(), 10)].blockType === 'text') {
                        contentToCopy = blocks[parseInt(i.toString(), 10)].content;
                        break;
                    }
                }
            }
            this.getClipBoardContent(SanitizeHtmlHelper.sanitize(contentToCopy));
            args.item.prefixIcon = 'e-icons e-assist-check';
            this.responseToolbarEle.dataBind();
            setTimeout(function () {
                args.item.prefixIcon = 'e-icons e-assist-copy';
                _this.responseToolbarEle.dataBind();
            }, 1000);
        }
        var icon = args.item.prefixIcon;
        var isLikeInteracted = icon === 'e-icons e-assist-like-filled' || icon === 'e-icons e-assist-like';
        var isDislikeInteracted = icon === 'e-icons e-assist-dislike-filled' || icon === 'e-icons e-assist-dislike';
        if (isLikeInteracted || isDislikeInteracted) {
            var isHelpful = null;
            if (isLikeInteracted) {
                isHelpful = this.prompts[parseInt(index.toString(), 10)].isResponseHelpful === true ? null : true;
            }
            else if (isDislikeInteracted) {
                isHelpful = this.prompts[parseInt(index.toString(), 10)].isResponseHelpful === false ? null : false;
            }
            var prevOnChange = this.isProtectedOnChange;
            this.isProtectedOnChange = true;
            this.prompts[parseInt(index.toString(), 10)].isResponseHelpful = isHelpful;
            var promptItem = this.prompts[parseInt(index.toString(), 10)];
            // eslint-disable-next-line  @typescript-eslint/no-explicit-any
            var controlParentItems = args.item.controlParent.items;
            var likeIndex = controlParentItems.findIndex(function (it) {
                return it.prefixIcon === 'e-icons e-assist-like' || it.prefixIcon === 'e-icons e-assist-like-filled';
            });
            var dislikeIndex = controlParentItems.findIndex(function (it) {
                return it.prefixIcon === 'e-icons e-assist-dislike' || it.prefixIcon === 'e-icons e-assist-dislike-filled';
            });
            if (isLikeInteracted) {
                if (promptItem.isResponseHelpful === true) {
                    args.item.prefixIcon = 'e-icons e-assist-like-filled';
                    if (controlParentItems && controlParentItems.length > 2) {
                        controlParentItems[parseInt(dislikeIndex.toString(), 10)].prefixIcon = 'e-icons e-assist-dislike';
                    }
                }
                else {
                    args.item.prefixIcon = 'e-icons e-assist-like';
                }
            }
            else if (isDislikeInteracted) {
                if (promptItem.isResponseHelpful === false) {
                    args.item.prefixIcon = 'e-icons e-assist-dislike-filled';
                    if (controlParentItems && controlParentItems.length > 1) {
                        controlParentItems[parseInt(likeIndex.toString(), 10)].prefixIcon = 'e-icons e-assist-like';
                    }
                }
                else {
                    args.item.prefixIcon = 'e-icons e-assist-dislike';
                }
            }
            this.responseToolbarEle.dataBind();
            this.isProtectedOnChange = prevOnChange;
        }
        // Built-in Text-to-Speech
        if (args.item.prefixIcon === 'e-icons e-assist-audio' ||
            args.item.prefixIcon === 'e-icons e-assist-stop') {
            if (this.currentUtterance) {
                speechSynthesis.cancel();
                this.currentUtterance = null;
                args.item.prefixIcon = 'e-icons e-assist-audio';
                args.item.tooltipText = this.l10n.getConstant('readAloud');
            }
            else {
                var contentBody = this.element.querySelector("#e-response-item_" + index + " .e-content-body");
                var cleanText = (contentBody && contentBody.innerText) ? contentBody.innerText.trim() : '';
                this.speakText(cleanText, args.item);
            }
            this.responseToolbarEle.dataBind();
        }
        // Built-in Regenerate Support
        if (args.item.prefixIcon === 'e-icons e-assist-regenerate') {
            this.handleRegenerateClick(index);
        }
    };
    AIAssistView.prototype.speakText = function (cleanText, item) {
        var _this = this;
        if (!cleanText) {
            return;
        }
        var utterance = new SpeechSynthesisUtterance(cleanText);
        utterance.lang = this.textToSpeechSettings.language;
        utterance.pitch = this.textToSpeechSettings.speechPitch;
        utterance.rate = this.textToSpeechSettings.speechRate;
        utterance.volume = this.textToSpeechSettings.volume;
        if (this.textToSpeechSettings.voice) {
            utterance.voice = this.textToSpeechSettings.voice;
        }
        utterance.onend = function () {
            _this.currentUtterance = null;
            item.prefixIcon = 'e-icons e-assist-audio';
            item.tooltipText = _this.l10n.getConstant('readAloud');
            if (_this.responseToolbarEle) {
                _this.responseToolbarEle.dataBind();
            }
        };
        speechSynthesis.speak(utterance);
        this.currentUtterance = utterance;
        item.prefixIcon = 'e-icons e-assist-stop';
        item.tooltipText = this.l10n.getConstant('stopAudio');
    };
    AIAssistView.prototype.renderPrompt = function (promptText, promptIndex, attachedFiles) {
        var _this = this;
        var outputPrompt = this.createElement('div', { attrs: { class: 'e-prompt-text', tabindex: '0' } });
        var promptFiles = this.createElement('div', { attrs: { class: 'e-prompt-uploaded-files' } });
        var promptContent = this.createElement('div', { className: 'e-prompt-content' });
        var promptDetails = this.createElement('div', { className: 'e-prompt-details' });
        var promptToolbarContainer = this.createElement('div', { className: 'e-prompt-toolbar' });
        var promptToolbar = this.createElement('div');
        var userIcon = this.createElement('span', { className: this.promptIconCss ? 'e-prompt-icon e-icons '
                + this.promptIconCss : '' });
        if (this.promptItemTemplate) {
            this.getContextObject('promptItemTemplate', this.outputSuggestionEle, promptIndex);
        }
        else {
            // Use getPromptText to render mention chips if mentions are available
            outputPrompt.innerHTML = this.getPromptText(promptText, promptIndex);
            var uploadedFiles = attachedFiles || this.uploadedFiles;
            if (uploadedFiles.length > 0) {
                uploadedFiles.forEach(function (file) {
                    promptFiles.appendChild(_this.createFileItem(file, false));
                });
                promptDetails.appendChild(promptFiles);
            }
            if (promptText.length > 0) {
                promptDetails.appendChild(outputPrompt);
            }
            promptContent.appendChild(promptDetails);
            if (this.promptIconCss) {
                promptContent.appendChild(userIcon);
            }
            this.outputSuggestionEle.append(promptContent);
        }
        this.renderPromptToolbar(promptToolbar, promptIndex);
        promptToolbarContainer.append(promptToolbar);
        this.appendChildren(this.outputSuggestionEle, promptToolbarContainer);
    };
    AIAssistView.prototype.renderPromptToolbar = function (element, promptIndex) {
        var _this = this;
        var pushToolbar = [];
        if (this.promptToolbarSettings.items.length === 0) {
            pushToolbar = [
                { prefixIcon: 'e-icons e-assist-edit', tooltipText: 'Edit' },
                { prefixIcon: 'e-icons e-assist-copy', tooltipText: 'Copy' }
            ];
            var prevOnChange = this.isProtectedOnChange;
            this.isProtectedOnChange = true;
            this.promptToolbarSettings.items = [
                { iconCss: 'e-icons e-assist-edit', tooltip: 'Edit' },
                { iconCss: 'e-icons e-assist-copy', tooltip: 'Copy' }
            ];
            this.isProtectedOnChange = prevOnChange;
        }
        else {
            pushToolbar = this.promptToolbarSettings.items.map(function (item) { return ({
                type: item.type,
                template: item.template,
                disabled: item.disabled,
                cssClass: item.cssClass,
                visible: item.visible,
                tooltipText: item.tooltip,
                prefixIcon: item.iconCss,
                text: item.text,
                align: item.align,
                width: _this.promptToolbarSettings.width,
                tabIndex: item.tabIndex
            }); });
        }
        this.promptToolbarEle = new Toolbar({
            items: pushToolbar,
            clicked: function (args) {
                var eventItemArgs = {
                    type: args.item.type,
                    text: args.item.text,
                    iconCss: args.item.prefixIcon,
                    cssClass: args.item.cssClass,
                    tooltip: args.item.tooltipText,
                    template: args.item.template,
                    disabled: args.item.disabled,
                    visible: args.item.visible,
                    align: args.item.align,
                    tabIndex: args.item.tabIndex
                };
                var eventArgs = {
                    item: eventItemArgs,
                    event: args.originalEvent,
                    cancel: false,
                    dataIndex: promptIndex
                };
                if (_this.promptToolbarSettings.itemClicked) {
                    _this.promptToolbarSettings.itemClicked.call(_this, eventArgs);
                }
                if (!eventArgs.cancel) {
                    if (args.item.prefixIcon === 'e-icons e-assist-edit') {
                        _this.onEditIconClick(promptIndex, args.originalEvent);
                    }
                    if (args.item.prefixIcon === 'e-icons e-assist-copy') {
                        _this.getClipBoardContent(_this.getPromptText(_this.prompts[parseInt(promptIndex.toString(), 10)].prompt, promptIndex, true));
                        args.item.prefixIcon = 'e-icons e-assist-check';
                        _this.promptToolbarEle.dataBind();
                        setTimeout(function () {
                            args.item.prefixIcon = 'e-icons e-assist-copy';
                            _this.promptToolbarEle.dataBind();
                        }, 1000);
                    }
                }
            }
        });
        this.promptToolbarEle.appendTo(element);
        this.promptToolbarEle.element.setAttribute('aria-label', "prompt-toolbar-" + promptIndex);
    };
    AIAssistView.prototype.renderSkeleton = function () {
        this.skeletonContainer = this.createElement('div', { className: 'e-output-container' });
        if (this.responseAnimationTemplate) {
            this.skeletonContainer.classList.add('e-response-animation-template');
            this.updateContent(this.responseAnimationTemplate, this.skeletonContainer, {}, 'responseAnimationTemplate');
        }
        else {
            var outputViewWrapper = this.createElement('div', { className: 'e-output', styles: 'width: 70%;' });
            var skeletonIconEle = this.createElement('span', { className: 'e-output-icon e-skeleton e-skeleton-text e-shimmer-wave' });
            var skeletonBodyEle = this.createElement('div', { className: 'e-loading-body' });
            var skeletonFooterEle = this.createElement('div', { className: 'e-loading-footer' });
            var _a = [
                this.createElement('div', { className: 'e-skeleton e-skeleton-text e-shimmer-wave', styles: 'width: 100%; height: 15px;' }),
                this.createElement('div', { className: 'e-skeleton e-skeleton-text e-shimmer-wave', styles: 'width: 75%; height: 15px;' }),
                this.createElement('div', { className: 'e-skeleton e-skeleton-text e-shimmer-wave', styles: 'width: 50%; height: 15px;' })
            ], skeletonLine1 = _a[0], skeletonLine2 = _a[1], skeletonLine3 = _a[2];
            var footerSkeleton = [
                this.createElement('div', { className: 'e-skeleton e-skeleton-text e-shimmer-wave', styles: 'width: 100%; height: 30px;' })
            ][0];
            this.appendChildren(skeletonBodyEle, skeletonLine1, skeletonLine2, skeletonLine3);
            skeletonFooterEle.append(footerSkeleton);
            this.appendChildren(outputViewWrapper, skeletonBodyEle, skeletonFooterEle);
            this.appendChildren(this.skeletonContainer, skeletonIconEle, outputViewWrapper);
        }
    };
    AIAssistView.prototype.onEditIconClick = function (promptIndex, event) {
        if (this.editableTextarea) {
            if (this.suggestionsElement) {
                this.suggestionsElement.hidden = true;
            }
            var prevOnChange = this.isProtectedOnChange;
            this.isProtectedOnChange = true;
            var prevPrompt = this.prompt;
            this.editableTextarea.innerHTML = this.prompt =
                this.getPromptText(this.prompts[parseInt(promptIndex.toString(), 10)].prompt, promptIndex);
            this.isProtectedOnChange = prevOnChange;
            // Restore selectedMentions array from stored prompt data
            this.restoreMentionsFromPrompt(promptIndex);
            this.refreshTextareaUI();
            this.editableTextarea.focus();
            this.setFocusAtEnd(this.editableTextarea);
            this.pushToUndoStack(this.prompt);
            this.redoStack = [];
            this.triggerPromptChanged(event, prevPrompt);
        }
    };
    AIAssistView.prototype.refreshTextareaUI = function () {
        this.updateHiddenTextarea(this.prompt);
        this.checkAndActivateSendIcon();
        this.updateFooterElementClass();
        this.updateFooterType(this.footerToolbarSettings.toolbarPosition);
        this.toggleClearIcon();
    };
    AIAssistView.prototype.checkAndActivateSendIcon = function () {
        if (!this.footerToolbarEle) {
            return;
        }
        var length = this.prompt.length > 0 ? this.prompt.length : this.uploadedFiles.length;
        if (this.sendToolbarItem.prefixIcon === 'e-icons e-assist-send') {
            var sendItem = this.footerToolbarEle.element.querySelector('.e-assist-send');
            if (sendItem) {
                if (length > 0) {
                    removeClass([sendItem], 'disabled');
                    sendItem.setAttribute('title', this.l10n.getConstant('send'));
                }
                else {
                    addClass([sendItem], 'disabled');
                }
            }
        }
    };
    AIAssistView.prototype.toggleClearIcon = function () {
        if (this.clearToolbarItem && this.footerToolbarEle) {
            var isFocused = document.activeElement === this.editableTextarea;
            var hasContent = this.editableTextarea.textContent.length > 0;
            var clearItemElement = this.footerToolbarEle.element.querySelector('.e-toolbar-item .e-icons.e-assist-clear-icon')
                .closest('.e-toolbar-item');
            if (clearItemElement) {
                if (isFocused && hasContent) {
                    this.footerToolbarEle.hideItem(clearItemElement, false);
                }
                else {
                    this.footerToolbarEle.hideItem(clearItemElement, true);
                }
            }
        }
    };
    AIAssistView.prototype.updateIcons = function (newCss, isPromptIconCss) {
        if (isPromptIconCss === void 0) { isPromptIconCss = false; }
        var elements;
        if (this.outputElement) {
            if (isPromptIconCss) {
                newCss = 'e-prompt-icon e-icons ' + newCss;
                elements = this.outputElement.querySelectorAll('.e-prompt-icon');
            }
            else {
                newCss = ' e-output-icon e-icons ' + newCss;
                elements = this.outputElement.querySelectorAll('.e-output-icon');
            }
        }
        for (var index = 0; index < (elements && elements.length); index++) {
            removeClass([elements[parseInt(index.toString(), 10)]], elements[parseInt(index.toString(), 10)].classList.toString().trim().split(' '));
            addClass([elements[parseInt(index.toString(), 10)]], newCss.trim().split(' '));
        }
    };
    AIAssistView.prototype.updateToolbarSettings = function (previousToolbar) {
        var previousToolbarIndex = 0;
        for (var index = this.views.length; index < this.toolbarItems.length; index++) {
            if (previousToolbar.items[parseInt(previousToolbarIndex.toString(), 10)] === this.toolbarItems[parseInt(index.toString(), 10)]) {
                this.toolbarItems.splice(index, 1);
            }
        }
        this.updateHeaderToolbar();
        this.toolbar.items = this.toolbarItems;
    };
    AIAssistView.prototype.updateAttachmentToolbarItemInSettings = function () {
        var prevOnChange = this.isProtectedOnChange;
        this.isProtectedOnChange = true;
        var items = this.footerToolbarSettings.items;
        var attachmentItemIndex = items.findIndex(function (item) { return item.iconCss === 'e-icons e-assist-attachment-icon'; });
        if (this.enableAttachments && attachmentItemIndex === -1) {
            var attachmentItem = {
                iconCss: 'e-icons e-assist-attachment-icon',
                tooltip: this.l10n.getConstant('attachments'),
                align: 'Right'
            };
            var sendItemIndex = items.findIndex(function (item) { return item.iconCss === 'e-icons e-assist-send'; });
            items.splice(sendItemIndex !== -1 ? sendItemIndex : items.length, 0, attachmentItem);
        }
        else if (!this.enableAttachments && attachmentItemIndex !== -1) {
            items.splice(attachmentItemIndex, 1);
        }
        this.isProtectedOnChange = prevOnChange;
    };
    AIAssistView.prototype.updateClearToolbarItemInSettings = function () {
        var prevOnChange = this.isProtectedOnChange;
        this.isProtectedOnChange = true;
        var items = this.footerToolbarSettings.items;
        var clearItemIndex = items.findIndex(function (item) { return item.iconCss === 'e-icons e-assist-clear-icon'; });
        if (this.showClearButton && clearItemIndex === -1) {
            var clearItem = {
                iconCss: 'e-icons e-assist-clear-icon',
                tooltip: this.l10n.getConstant('clear'),
                align: 'Right'
            };
            var sendItemIndex = items.findIndex(function (item) { return item.iconCss === 'e-icons e-assist-send'; });
            items.splice(sendItemIndex !== -1 ? sendItemIndex : items.length, 0, clearItem);
        }
        else if (!this.showClearButton && clearItemIndex !== -1) {
            items.splice(clearItemIndex, 1);
        }
        this.isProtectedOnChange = prevOnChange;
    };
    AIAssistView.prototype.updateFooterToolbar = function () {
        var footerIconsWrapper = this.footer.querySelector('.e-footer-icons-wrapper');
        if (footerIconsWrapper) {
            var leftItems = this.footer.querySelector('.e-footer-left-items');
            if (leftItems) {
                this.destroyAndNullify(this.footerLeftToolbarEle);
                remove(leftItems);
            }
            footerIconsWrapper.innerHTML = '';
            this.footerToolbarEle = null;
            this.sendToolbarItem = null;
            this.clearToolbarItem = null;
            this.attachmentToolbarItem = null;
            this.renderFooterToolbar(footerIconsWrapper);
            this.refreshTextareaUI();
        }
    };
    AIAssistView.prototype.updateResponse = function (response, index, isFinalUpdate, responseItem, block, blocksLength) {
        if (!this.responseItemTemplate && responseItem) {
            var outputEle = responseItem.querySelector('.e-output');
            var outputContentBodyEle = responseItem.querySelector('.e-content-body');
            if (response && !this.isToolResponse) {
                if (outputContentBodyEle) {
                    //outputContentBodyEle.innerHTML = response;
                    this.updateDynamicResponse(outputContentBodyEle, isFinalUpdate, response, blocksLength);
                }
            }
            else if (this.isToolResponse) {
                var textContainers = outputContentBodyEle.querySelectorAll('.e-text');
                var textContainer = textContainers[textContainers.length - 1];
                if (textContainer) {
                    textContainer.innerHTML = block.content;
                }
            }
            if (isFinalUpdate && this.suggestionsElement) {
                this.suggestionsElement.hidden = false;
            }
            if (isFinalUpdate) {
                this.renderPreTag(outputContentBodyEle);
            }
            if (isFinalUpdate && outputEle.querySelector('.e-content-footer') === null) {
                this.renderOutputToolbarItems(index, isFinalUpdate);
                this.appendChildren(outputEle, this.contentFooterEle);
            }
        }
        else if (this.responseItemTemplate && responseItem) {
            // Template is configured AND container exists: update it instead of creating duplicate
            var prevOnChange = this.isProtectedOnChange;
            this.isProtectedOnChange = true;
            // Update the prompt model with accumulated response
            if (index < this.prompts.length) {
                this.prompts[parseInt(index.toString(), 10)].response = response;
            }
            this.isProtectedOnChange = prevOnChange;
            // Re-render template with updated data
            var outputEle = responseItem.querySelector('.e-output');
            if (outputEle) {
                outputEle.innerHTML = '';
                this.getContextObject('responseItemTemplate', outputEle, index);
                // Remove skeleton if present
                if (this.hasSkeletonEle() || this.outputElement.querySelector('.e-skeleton')) {
                    this.outputElement.removeChild(this.skeletonContainer);
                }
                // Handle final update: toolbar and suggestions
                if (isFinalUpdate) {
                    if (this.suggestionsElement) {
                        this.suggestionsElement.hidden = false;
                    }
                    if (this.contentFooterEle) {
                        this.contentFooterEle.classList.remove('e-assist-toolbar-active');
                    }
                    if (this.hasStopResponseButton()) {
                        this.toggleStopRespondingButton(false);
                    }
                    this.renderOutputToolbarItems(index, isFinalUpdate);
                    this.appendChildren(outputEle, this.contentFooterEle);
                }
            }
        }
        else {
            // Template is configured BUT container doesn't exist yet: create it
            this.renderOutputContainer(undefined, response, undefined, index, false, isFinalUpdate);
        }
    };
    AIAssistView.prototype.streamText = function (text, onUpdate, onComplete, countTelemetry) {
        var _this = this;
        if (countTelemetry === void 0) { countTelemetry = true; }
        if (!text || !text.trim()) {
            if (onComplete) {
                onComplete();
            }
            return;
        }
        var i = 0;
        var words = text.split(' ');
        var lastResponse = '';
        var streamingText = function () {
            if (_this.isOutputRenderingStop || !_this.contentWrapper) {
                if (onComplete) {
                    onComplete();
                }
                return;
            }
            if (i < words.length) {
                lastResponse += (i === 0 ? '' : ' ') + words[i++];
                if (countTelemetry) {
                    // collecting streamingChunks count here
                    _this.activeTurnChunkCount++;
                }
                onUpdate(lastResponse, false);
                if (!_this.isRegenerating) {
                    _this.scrollToBottom();
                }
                setTimeout(streamingText, 15);
            }
            else {
                onUpdate(lastResponse, true);
                if (onComplete) {
                    onComplete();
                }
            }
        };
        streamingText();
    };
    AIAssistView.prototype.resetRegeneratingState = function () {
        this.isRegenerating = false;
        this.regeneratingPromptIndex = -1;
    };
    AIAssistView.prototype.streamResponse = function (response, index, blocksLength, onStreamingComplete) {
        var _this = this;
        var prevOnChange = this.isProtectedOnChange;
        this.isProtectedOnChange = true;
        this.streamText(response, function (lastResponse, isComplete) {
            if (index >= _this.prompts.length) {
                _this.isResponseRequested = false;
                return;
            }
            var responseItem = _this.element.querySelector("#e-response-item_" + index);
            if (_this.isRegenerating) {
                if (responseItem) {
                    var contentBody = responseItem.querySelector('.e-content-body');
                    if (contentBody && contentBody.firstChild && contentBody.children.length === 1
                        && (contentBody.querySelector('.e-skeleton') || contentBody.querySelector('.e-output-container .e-response-animation-template'))) {
                        contentBody.removeChild(contentBody.firstChild);
                    }
                }
            }
            else if (_this.hasSkeletonEle() || _this.outputElement.querySelector('.e-skeleton')) {
                _this.outputElement.removeChild(_this.skeletonContainer);
            }
            _this.updateResponse(lastResponse, index, isComplete, responseItem, null, blocksLength);
            _this.setupViewportFilling();
            if (isComplete) {
                if (_this.hasStopResponseButton()) {
                    _this.toggleStopRespondingButton(false);
                }
                _this.isResponseRequested = false;
                if (_this.isRegenerating) {
                    _this.resetRegeneratingState();
                }
            }
        }, onStreamingComplete);
        this.isProtectedOnChange = prevOnChange;
    };
    AIAssistView.prototype.streamToolResponse = function (response, element, streamingCompleted) {
        var prevOnChange = this.isProtectedOnChange;
        this.isProtectedOnChange = true;
        this.streamText(response, function (lastResponse) {
            element.innerHTML = lastResponse;
        }, streamingCompleted, false);
        this.isProtectedOnChange = prevOnChange;
    };
    AIAssistView.prototype.updateBannerTemplate = function (newTemplate) {
        if (!isNOU(newTemplate)) {
            var contentContainer = this.element.querySelector('.e-view-container');
            var existingTemplate = contentContainer.querySelector('.e-banner-view');
            if (existingTemplate) {
                existingTemplate.remove();
            }
            this.updateBannerView(contentContainer);
        }
    };
    AIAssistView.prototype.updateResponseAnimationTemplate = function (newTemplate) {
        var prevSkeleton = this.skeletonContainer;
        this.renderSkeleton();
        if (prevSkeleton && prevSkeleton.parentElement) {
            prevSkeleton.parentElement.replaceChild(this.skeletonContainer, prevSkeleton);
        }
    };
    AIAssistView.prototype.updatePromptSuggestionTemplate = function () {
        if (this.suggestionsElement) {
            this.suggestionsElement.remove();
        }
        if (!this.isOutputRenderingStop) {
            this.renderSuggestions(this.promptSuggestions, this.promptSuggestionsHeader, this.promptSuggestionItemTemplate, 'promptSuggestion', 'promptSuggestionItemTemplate', this.onSuggestionClick);
        }
    };
    AIAssistView.prototype.updateFooterTemplate = function () {
        this.footer.innerHTML = '';
        this.updateFooterClass(this.footerTemplate);
        this.unWireFooterEvents(this.footerTemplate);
        this.renderAssistViewFooter();
        if (!this.footerTemplate) {
            this.wireFooterEvents(this.footerTemplate);
        }
    };
    AIAssistView.prototype.updateAttachmentSettings = function (newAttachment) {
        if (!isNOU(newAttachment.allowedFileTypes)) {
            this.uploaderObj.allowedExtensions = newAttachment.allowedFileTypes;
        }
        if (!isNOU(newAttachment.maxFileSize)) {
            this.uploaderObj.maxFileSize = newAttachment.maxFileSize;
        }
        this.uploaderObj.asyncSettings = {
            saveUrl: !isNOU(newAttachment.saveUrl) ? newAttachment.saveUrl : this.uploaderObj.asyncSettings.saveUrl,
            removeUrl: !isNOU(newAttachment.removeUrl) ? newAttachment.removeUrl : this.uploaderObj.asyncSettings.removeUrl
        };
    };
    AIAssistView.prototype.handleSTTDynamicChange = function (newProp, oldProp) {
        if (oldProp.enable !== newProp.enable) {
            this.updateFooterToolbar();
            this.updateSpeechToTextSettings(newProp);
        }
        if (isNOU(this.speechToTextObj)) {
            return;
        }
        if (oldProp.allowInterimResults !== newProp.allowInterimResults) {
            this.speechToTextObj.allowInterimResults = newProp.allowInterimResults;
        }
        if (oldProp.buttonSettings !== newProp.buttonSettings) {
            this.speechToTextObj.buttonSettings = newProp.buttonSettings;
        }
        if (oldProp.tooltipSettings !== newProp.tooltipSettings) {
            this.speechToTextObj.tooltipSettings = newProp.tooltipSettings;
        }
        if (oldProp.showTooltip !== newProp.showTooltip) {
            this.speechToTextObj.showTooltip = newProp.showTooltip;
        }
        if (oldProp.cssClass !== newProp.cssClass) {
            this.speechToTextObj.cssClass = newProp.cssClass;
        }
        if (oldProp.disabled !== newProp.disabled) {
            this.speechToTextObj.disabled = newProp.disabled;
        }
        if (oldProp.lang !== newProp.lang) {
            this.speechToTextObj.lang = newProp.lang;
        }
        if (oldProp.listeningState !== newProp.listeningState) {
            this.speechToTextObj.listeningState = newProp.listeningState;
        }
        this.speechToTextObj.dataBind();
    };
    AIAssistView.prototype.updateSpeechToTextSettings = function (newProps) {
        this.renderSpeechToText();
        if (this.speechToTextObj == null) {
            return;
        }
        this.speechToTextObj.allowInterimResults = newProps.allowInterimResults;
        this.speechToTextObj.transcript = newProps.transcript;
        this.speechToTextObj.lang = newProps.lang || 'en-US';
        this.speechToTextObj.disabled = newProps.disabled;
        this.speechToTextObj.buttonSettings = newProps.buttonSettings;
        this.speechToTextObj.showTooltip = newProps.showTooltip;
        this.speechToTextObj.tooltipSettings = newProps.tooltipSettings;
        this.speechToTextObj.cssClass = newProps.cssClass;
    };
    AIAssistView.prototype.updateLocale = function () {
        // Update file upload failure locale
        this.l10n.setLocale(this.locale);
        var failureElement = this.viewWrapper.querySelector('.e-upload-failure-alert');
        if (failureElement) {
            var failureMessageEle = failureElement.querySelector('.e-failure-message');
            if (failureMessageEle.classList.contains('e-size-failure')) {
                failureMessageEle.textContent = this.l10n.getConstant('fileSizeFailure');
            }
            else {
                var failureText = this.l10n.getConstant('fileCountFailure');
                failureText = failureText.replace('{0}', this.attachmentSettings.maximumCount.toString());
                if (this.attachmentSettings.maximumCount === 1) {
                    failureText = failureText.replace('files', 'file');
                }
                failureMessageEle.textContent = failureText;
            }
        }
        // Update mention popups with localized noRecordsTemplate
        if (this.mentionModels && this.mentionModels.length > 0) {
            for (var _i = 0, _a = this.mentionModels; _i < _a.length; _i++) {
                var mention = _a[_i];
                if (mention) {
                    mention.noRecordsTemplate = this.l10n.getConstant('noRecordsTemplate');
                }
            }
        }
    };
    AIAssistView.prototype.destroy = function () {
        if (this.currentUtterance) {
            speechSynthesis.cancel();
            this.currentUtterance = null;
        }
        // Telemetry — reset scratch state (no work if telemetry is off, but be defensive)
        this.resetActiveTurn();
        _super.prototype.destroy.call(this);
        this.unWireEvents();
        this.destroyAndNullify(this.responseToolbarEle);
        this.destroyAndNullify(this.promptToolbarEle);
        this.destroyAndNullify(this.footerToolbarEle);
        this.destroyAndNullify(this.footerLeftToolbarEle);
        this.destroyAndNullify(this.downArrowIcon);
        this.destroyAndNullify(this.toolbar);
        this.destroyAndNullify(this.speechToTextObj);
        this.destroyAssistView();
        //private html elements nullify
        remove(this.viewWrapper);
        this.viewWrapper = null;
        this.aiAssistViewRendered = null;
        this.assistViewTemplateIndex = null;
        this.toolbarItems = [];
        this.displayContents = [];
        this.isOutputRenderingStop = false;
        this.isResponseRequested = null;
        this.suggestionHeader = null;
        this.previousElement = null;
        this.assistCustomSection = null;
        this.speechToTextToolbarItem = null;
        this.preTagElements = [];
        this.regeneratedResponses.clear();
        this.regeneratedBlocks.clear();
        this.currentRegeneratedIndex.clear();
        this.originalBlocks.clear();
        this.isRegenerating = false;
        this.regeneratingPromptIndex = -1;
        this.registeredTools.clear();
        this.mentionModels = [];
        this.selectedMentions = [];
        this.mentionCounter = 0;
        this.telemetryReportsByPrompt.clear();
        this.telemetryTooltipsByPrompt.forEach(function (tip) {
            if (tip) {
                tip.destroy();
            }
        });
        this.telemetryTooltipsByPrompt.clear();
        // properties nullify
        this.toolbarSettings = this.promptToolbarSettings = this.responseToolbarSettings = {};
        if (this.cssClass) {
            removeClass([this.element], this.cssClass.split(' '));
        }
        this.element.classList.remove('e-rtl');
    };
    AIAssistView.prototype.destroyAssistView = function () {
        var properties = [
            'toolbarHeader',
            'sendIcon',
            'clearIcon',
            'suggestions',
            'skeletonContainer',
            'outputElement',
            'outputSuggestionEle',
            'contentFooterEle',
            'editableTextarea',
            'footer',
            'speechToTextToolbarItem',
            'assistCustomSection',
            'content',
            'stopResponding',
            'contentWrapper'
        ];
        for (var _i = 0, properties_1 = properties; _i < properties_1.length; _i++) {
            var prop = properties_1[_i];
            var element = prop;
            this.removeAndNullify(this[element]);
            this[element] = null;
        }
    };
    /**
     * Executes the specified prompt in the AIAssistView component. The method accepts a string representing the prompt.
     *
     * @param {string} prompt - The prompt text to be executed. It must be a non-empty string.
     *
     * @returns {void}
     */
    AIAssistView.prototype.executePrompt = function (prompt) {
        if (!isNOU(prompt) && prompt.trim().length > 0) {
            var prevOnChange = this.isProtectedOnChange;
            this.isProtectedOnChange = true;
            this.prompt = prompt;
            this.isProtectedOnChange = prevOnChange;
            this.onSendIconClick();
        }
    };
    /**
     * Registers a custom tool UI for rendering AI-generated tool responses.
     * Use this method to define how specific tool blocks should be rendered in the AIAssistView.
     *
     * @param {ToolUIConfig} tool - Configuration object containing toolName, template, and optional handler callback
     * @returns {void}
     *
     */
    AIAssistView.prototype.registerToolUI = function (tool) {
        if (tool.toolName) {
            var name_1 = tool.toolName.toLowerCase();
            this.registeredTools.set(name_1, { toolName: name_1, template: tool.template, handler: tool.handler });
        }
    };
    /**
     * Adds or updates a response in the AIAssistView component.
     * Accepts response content, update state, and optional telemetry enrichment data.
     *
     * @param {string | Object} outputResponse - Specifies the response content or prompt-response object to add or update.
     * @param {boolean} isFinalUpdate - Indicates whether the response update is complete.
     * @param {TelemetryData} [telemetryData] - Provides optional model, token, and custom telemetry data.
     * @returns {void}
     */
    AIAssistView.prototype.addPromptResponse = function (outputResponse, isFinalUpdate, telemetryData) {
        var _this = this;
        if (isFinalUpdate === void 0) { isFinalUpdate = true; }
        var prevOnChange = this.isProtectedOnChange;
        this.isProtectedOnChange = true;
        if (!outputResponse) {
            this.isResponseRequested = false;
            this.isProtectedOnChange = prevOnChange;
            return;
        }
        if (this.isRegenerating && this.regeneratingPromptIndex >= 0 && this.regeneratingPromptIndex < this.prompts.length) {
            var regenerateIndex = this.regeneratingPromptIndex;
            var responseText = this.extractResponseText(outputResponse);
            var blocks = typeof outputResponse === 'object' && outputResponse !== null && !isNOU(outputResponse.blocks)
                ? outputResponse.blocks
                : [];
            // eslint-disable-next-line security/detect-object-injection
            var responseHistory = this.regeneratedResponses.get(regenerateIndex) || [this.prompts[regenerateIndex].response];
            responseHistory.push(responseText);
            this.regeneratedResponses.set(regenerateIndex, responseHistory);
            // Store corresponding blocks
            var blocksHistory = this.regeneratedBlocks.get(regenerateIndex) ||
                [this.prompts[regenerateIndex].blocks || []];
            blocksHistory.push(blocks);
            this.regeneratedBlocks.set(regenerateIndex, blocksHistory);
            this.currentRegeneratedIndex.set(regenerateIndex, responseHistory.length - 1);
            // eslint-disable-next-line security/detect-object-injection
            this.prompts[regenerateIndex].response = responseText;
            this.prompts[regenerateIndex].blocks = blocks;
            var responseContainer = this.element.querySelector("#e-response-item_" + regenerateIndex);
            if (responseContainer) {
                if (this.responseItemTemplate) {
                    this.updateResponse(responseText, regenerateIndex, isFinalUpdate, responseContainer);
                }
                else {
                    var contentBody = responseContainer.querySelector('.e-content-body');
                    if (contentBody) {
                        if (this.enableStreaming) {
                            var blocksLength = typeof outputResponse === 'object' && outputResponse !== null && !isNOU(outputResponse.blocks)
                                ? outputResponse.blocks.length
                                : 0;
                            this.streamResponse(responseText, regenerateIndex, blocksLength);
                        }
                        else {
                            var htmlResponse = MarkdownConverter.toHtml(responseText);
                            contentBody.innerHTML = htmlResponse;
                            this.renderPreTag(contentBody);
                        }
                        var navigationContainer = responseContainer.querySelector('.e-response-navigation-container');
                        if (navigationContainer) {
                            navigationContainer.classList.remove('e-response-hidden');
                        }
                    }
                }
                var toolbarWrapper = responseContainer.querySelector('.e-response-toolbar-wrapper');
                if (toolbarWrapper) {
                    toolbarWrapper.classList.remove('e-response-hidden');
                }
                var oldNav = responseContainer.querySelector('.e-response-navigation-container');
                var footer = responseContainer.querySelector('.e-content-footer');
                if (oldNav) {
                    this.updateNavigationUI(regenerateIndex, oldNav);
                }
                else if (responseHistory.length >= 2 && footer) {
                    var newNav = this.renderResponseNavigation(regenerateIndex);
                    if (newNav && newNav.children.length > 0) {
                        footer.insertBefore(newNav, footer.firstChild);
                    }
                }
            }
            if (isFinalUpdate) {
                if (!this.enableStreaming) {
                    this.resetRegeneratingState();
                    if (this.hasStopResponseButton()) {
                        this.toggleStopRespondingButton(false);
                    }
                }
            }
            this.isResponseRequested = false;
            this.isProtectedOnChange = prevOnChange;
            if (this.enableScrollToBottom && this.downArrowIcon && this.outputContentBodyEle && this.contentWrapper) {
                this.downArrowIcon.visible = this.outputContentBodyEle.scrollHeight > this.contentWrapper.clientHeight;
            }
            return;
        }
        if (!this.isOutputRenderingStop) {
            var responseItem_1 = this.element.querySelector("#e-response-item_" + (this.prompts.length - 1));
            var lastPrompt_1 = this.prompts[this.prompts.length - 1];
            if (!lastPrompt_1) {
                this.prompts = this.prompts.concat([{
                        prompt: null,
                        response: null,
                        isResponseHelpful: null,
                        attachedFiles: null,
                        blocks: []
                    }]);
                lastPrompt_1 = this.prompts[this.prompts.length - 1];
                this.lastRenderedBlockCount = 0;
            }
            var terminalUpdate = isFinalUpdate;
            var processResponse = function (rawResponse, blocks) {
                if (_this.enableStreaming && !_this.isToolResponse) {
                    if (_this.prompts.length === 0) {
                        _this.isResponseRequested = false;
                        return;
                    }
                    isFinalUpdate = false;
                    var htmlResponse = MarkdownConverter.toHtml(rawResponse);
                    lastPrompt_1.response = htmlResponse;
                    _this.streamResponse(lastPrompt_1.response, _this.prompts.length - 1, isNOU(blocks) ? 0 : blocks.length, function () { return _this.emitTelemetryReport('completed', telemetryData); });
                }
                else {
                    if (_this.prompts.length === 0) {
                        _this.isResponseRequested = false;
                        return;
                    }
                    lastPrompt_1.response = rawResponse ? MarkdownConverter.toHtml(rawResponse) : rawResponse;
                    if (!_this.isToolResponse) {
                        _this.updateResponse(lastPrompt_1.response, _this.prompts.length - 1, isFinalUpdate, responseItem_1, null, isNOU(blocks) ? 0 : blocks.length);
                    }
                    else {
                        if (!blocks) {
                            return;
                        }
                        blocks.forEach(function (block) {
                            if (block.blockType === 'text') {
                                _this.updateResponse(lastPrompt_1.response, _this.prompts.length - 1, isFinalUpdate, responseItem_1, block);
                            }
                        });
                        _this.updateLastThinkingBlock(blocks);
                        if (rawResponse) {
                            _this.isToolResponse = false;
                            if (_this.enableStreaming) {
                                _this.streamResponse(lastPrompt_1.response, _this.prompts.length - 1, isNOU(blocks) ? 0 : blocks.length, function () { return _this.emitTelemetryReport('completed', telemetryData); });
                            }
                            else {
                                _this.updateResponse(lastPrompt_1.response, _this.prompts.length - 1, isFinalUpdate, responseItem_1, null, isNOU(blocks) ? 0 : blocks.length);
                            }
                        }
                    }
                }
            };
            if (typeof outputResponse === 'string') {
                if (!this.isResponseRequested) {
                    this.prompts = this.prompts.concat([{ prompt: null, response: null, isResponseHelpful: null, attachedFiles: null,
                            blocks: [] }]);
                    lastPrompt_1 = this.prompts[this.prompts.length - 1];
                    this.lastRenderedBlockCount = 0;
                }
                this.isToolResponse = false;
                processResponse(outputResponse);
            }
            // Tracks whether the streaming blocks-only path already emitted
            var telemetryHandledByStreamingBlocks = false;
            if (typeof outputResponse === 'object') {
                if (this.enableStreaming) {
                    isFinalUpdate = false;
                }
                var tPrompt = {
                    prompt: outputResponse.prompt,
                    attachedFiles: outputResponse.attachedFiles,
                    response: outputResponse.response,
                    isResponseHelpful: isNOU(outputResponse.isResponseHelpful) ? null :
                        outputResponse.isResponseHelpful,
                    blocks: outputResponse.blocks
                };
                this.isToolResponse = tPrompt.blocks ? tPrompt.blocks.length > 0 ? true : false : false;
                if (this.prompt === tPrompt.prompt || this.lastStreamPrompt === tPrompt.prompt) {
                    lastPrompt_1.attachedFiles = tPrompt.attachedFiles;
                    lastPrompt_1.isResponseHelpful = tPrompt.isResponseHelpful;
                    lastPrompt_1.blocks = tPrompt.blocks;
                    var hasBlocksOnly = Array.isArray(tPrompt.blocks) && tPrompt.blocks.length > 0 && (isNOU(tPrompt.response) || tPrompt.response === '');
                    // Check if this is a newly created prompt (when blocks-only called with no existing prompts)
                    var isNewlyCreatedPrompt = lastPrompt_1.prompt === null && lastPrompt_1.response === null;
                    // Render blocks only if: hasBlocksOnly AND responseItem exists AND (existing prompt OR template exists for new prompt)
                    if (hasBlocksOnly && responseItem_1 && !this.responseItemTemplate && !isNewlyCreatedPrompt) {
                        var outputEle = responseItem_1.querySelector('.e-output');
                        var outputContentBodyEle = responseItem_1.querySelector('.e-content-body');
                        if (!outputContentBodyEle) {
                            outputContentBodyEle = this.createElement('div', { attrs: { class: 'e-content-body', tabindex: '0' } });
                            if (outputEle) {
                                outputEle.appendChild(outputContentBodyEle);
                            }
                        }
                        this.renderResponseSegments(outputContentBodyEle, tPrompt.blocks, isFinalUpdate);
                        if (this.outputElement.querySelector('.e-skeleton')) {
                            this.outputElement.removeChild(this.skeletonContainer);
                        }
                        if (this.enableStreaming && terminalUpdate) {
                            this.renderOutputToolbarItems(this.prompts.length - 1, true);
                            telemetryHandledByStreamingBlocks = true;
                        }
                    }
                    else {
                        processResponse(tPrompt.response, tPrompt.blocks);
                    }
                }
                else {
                    if (!this.isResponseRequested) {
                        this.prompts = this.prompts.concat([tPrompt]);
                        lastPrompt_1 = this.prompts[this.prompts.length - 1];
                    }
                    lastPrompt_1.blocks = tPrompt.blocks;
                    this.lastRenderedBlockCount = 0;
                    this.renderOutputContainer(tPrompt.prompt, tPrompt.response, tPrompt.attachedFiles, this.prompts.length - 1, true, isFinalUpdate, tPrompt.blocks);
                    var isStreamingBlocksOnly = this.enableStreaming && terminalUpdate && !isFinalUpdate &&
                        Array.isArray(tPrompt.blocks) && tPrompt.blocks.length > 0 &&
                        (isNOU(tPrompt.response) || tPrompt.response === '');
                    if (isStreamingBlocksOnly) {
                        this.renderOutputToolbarItems(this.prompts.length - 1, true);
                        telemetryHandledByStreamingBlocks = true;
                    }
                }
                if (!isFinalUpdate) {
                    this.lastStreamPrompt = tPrompt.prompt;
                }
            }
            if (isFinalUpdate) {
                this.setupViewportFilling();
            }
            if (!this.enableStreaming && !this.isToolResponse) {
                if (isFinalUpdate && this.hasStopResponseButton()) {
                    this.toggleStopRespondingButton(false);
                }
                this.isResponseRequested = !isFinalUpdate;
            }
            if (this.prompts && this.prompts.length > 0) {
                var lastBlocks = this.prompts[this.prompts.length - 1].blocks || [];
                this.activeTurnToolCalls = this.deriveToolCalls(lastBlocks) || 0;
            }
            // Emit telemetry here for streaming blocks-only flows; text streaming reports elsewhere.
            if (terminalUpdate && telemetryHandledByStreamingBlocks) {
                this.emitTelemetryReport('completed', telemetryData);
            }
            if (terminalUpdate) {
                if (!this.enableStreaming) {
                    this.emitTelemetryReport('completed', telemetryData);
                }
            }
        }
        this.isProtectedOnChange = prevOnChange;
        if (this.enableScrollToBottom && this.downArrowIcon && this.outputContentBodyEle && this.contentWrapper) {
            this.downArrowIcon.visible = this.outputContentBodyEle.scrollHeight > this.contentWrapper.clientHeight;
        }
    };
    /**
     * Scrolls the view to the bottom to display the most recent response in the AIAssistView component.
     *
     * This method programmatically scrolls the view to the bottom,
     * typically used when new responses are added or to refocus on the latest response.
     *
     * @returns {void}
     */
    AIAssistView.prototype.scrollToBottom = function () {
        if (this.contentWrapper) {
            this.updateScroll(this.contentWrapper);
        }
    };
    AIAssistView.prototype.updateMentionObjs = function () {
        if (this.editableTextarea) {
            this.destroyAndNullifyMentions();
            this.initializeMentions();
        }
    };
    AIAssistView.prototype.destroyAndNullifyMentions = function () {
        if (this.mentionModels && this.mentionModels.length > 0) {
            for (var _i = 0, _a = this.mentionModels; _i < _a.length; _i++) {
                var mention = _a[_i];
                if (mention && mention.destroy) {
                    mention.destroy();
                }
            }
            this.mentionModels = [];
            this.selectedMentions = [];
            this.mentionCounter = 0;
        }
    };
    /**
     * Called if any of the property value is changed.
     *
     * @param  {AIAssistViewModel} newProp - Specifies new properties
     * @param  {AIAssistViewModel} oldProp - Specifies old properties
     * @returns {void}
     * @private
     */
    AIAssistView.prototype.onPropertyChanged = function (newProp, oldProp) {
        for (var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++) {
            var prop = _a[_i];
            switch (prop) {
                case 'width':
                case 'height':
                    this.setDimension(this.element, this.width, this.height);
                    break;
                case 'cssClass':
                    this.updateCssClass(this.element, newProp.cssClass, oldProp.cssClass);
                    break;
                case 'promptIconCss':
                    this.updateIcons(newProp.promptIconCss, true);
                    break;
                case 'responseIconCss':
                    this.updateIcons(newProp.responseIconCss);
                    break;
                case 'showHeader':
                    this.updateHeader(this.showHeader, this.toolbarHeader, this.viewWrapper);
                    break;
                case 'promptSuggestions':
                    this.updatePromptSuggestionTemplate();
                    break;
                case 'showClearButton':
                    if (this.footerTemplate) {
                        return;
                    }
                    else {
                        this.updateClearToolbarItemInSettings();
                        this.updateFooterToolbar();
                    }
                    break;
                case 'promptPlaceholder':
                    this.updatePlaceholder(this.promptPlaceholder);
                    break;
                case 'promptSuggestionsHeader': {
                    this.suggestionHeader.innerHTML = this.promptSuggestionsHeader;
                    var suggestionHeaderElem = this.element.querySelector('.e-suggestions .e-suggestion-header');
                    if (!suggestionHeaderElem) {
                        this.suggestionsElement.append(this.suggestionHeader);
                    }
                    break;
                }
                case 'activeView': {
                    var previousViewIndex = this.getIndex(oldProp.activeView);
                    this.updateActiveView(previousViewIndex);
                    break;
                }
                case 'enableRtl':
                    this.element.classList[this.enableRtl ? 'add' : 'remove']('e-rtl');
                    if (!isNOU(this.toolbar)) {
                        this.toolbar.enableRtl = this.enableRtl;
                        this.toolbar.dataBind();
                    }
                    break;
                case 'toolbarSettings':
                    this.updateToolbarSettings(oldProp.toolbarSettings);
                    break;
                case 'footerToolbarSettings':
                    if (newProp.footerToolbarSettings.items || newProp.footerToolbarSettings.toolbarPosition) {
                        this.updateFooterToolbar();
                    }
                    if (newProp.footerToolbarSettings.toolbarPosition) {
                        this.updateFooterType(newProp.footerToolbarSettings.toolbarPosition);
                    }
                    break;
                case 'promptToolbarSettings':
                case 'responseToolbarSettings':
                case 'prompts':
                    this.isOutputRenderingStop = false;
                    if (this.outputElement) {
                        remove(this.outputElement);
                    }
                    if (this.hasStopResponseButton()) {
                        this.toggleStopRespondingButton(false);
                    }
                    this.aiAssistViewRendered = false;
                    this.latestResponseMinHeight = null;
                    this.regeneratedResponses.clear();
                    this.regeneratedBlocks.clear();
                    this.currentRegeneratedIndex.clear();
                    this.originalResponses.clear();
                    this.originalBlocks.clear();
                    this.isRegenerating = false;
                    this.regeneratingPromptIndex = -1;
                    this.telemetryTooltipsByPrompt.forEach(function (tip) {
                        if (tip) {
                            tip.destroy();
                        }
                    });
                    this.telemetryTooltipsByPrompt.clear();
                    this.telemetryReportsByPrompt.clear();
                    this.renderOutputContent(true);
                    this.detachCodeCopyEventHandler();
                    if (this.bannerTemplate) {
                        this.updateBannerTemplate(this.bannerTemplate);
                    }
                    this.checkIsScrollable();
                    this.setupViewportFilling();
                    break;
                case 'prompt':
                    if (!this.footerTemplate) {
                        this.editableTextarea.innerText = this.prompt;
                        this.refreshTextareaUI();
                        this.pushToUndoStack(this.prompt);
                    }
                    break;
                case 'locale':
                    this.updateLocale();
                    break;
                case 'bannerTemplate': {
                    this.updateBannerTemplate(newProp.bannerTemplate);
                    break;
                }
                case 'promptSuggestionItemTemplate': {
                    if (!isNOU(newProp.promptSuggestionItemTemplate)) {
                        this.updatePromptSuggestionTemplate();
                    }
                    break;
                }
                case 'footerTemplate': {
                    this.updateFooterTemplate();
                    break;
                }
                case 'enableStreaming': {
                    this.enableStreaming = newProp.enableStreaming;
                    break;
                }
                case 'enableAttachments': {
                    if (!this.footerTemplate) {
                        this.updateAttachmentToolbarItemInSettings();
                        this.updateFooterToolbar();
                    }
                    break;
                }
                case 'responseAnimationTemplate': {
                    this.updateResponseAnimationTemplate(newProp.responseAnimationTemplate);
                    break;
                }
                case 'enableScrollToBottom': {
                    if (this.enableScrollToBottom) {
                        this.bindScroll();
                    }
                    else {
                        this.unBindScroll();
                    }
                    break;
                }
                case 'attachmentSettings':
                    this.updateAttachmentSettings(newProp.attachmentSettings);
                    break;
                case 'speechToTextSettings':
                    this.handleSTTDynamicChange(newProp.speechToTextSettings, oldProp.speechToTextSettings);
                    break;
                case 'telemetrySettings': {
                    var next = newProp.telemetrySettings;
                    var prev = null;
                    if (!isNullOrUndefined(oldProp) && !isNullOrUndefined(oldProp.telemetrySettings)) {
                        prev = oldProp.telemetrySettings;
                    }
                    var nextEnabled = !!(next && next.enable === true);
                    var prevEnabled = !!(prev && prev.enable === true);
                    if (nextEnabled !== prevEnabled) {
                        if (nextEnabled) {
                            this.addTelemetryToolbarForAllResponses();
                        }
                        else {
                            this.removeTelemetryToolbarForAllResponses();
                        }
                    }
                    break;
                }
                case 'mentions':
                    this.updateMentionObjs();
                    break;
            }
        }
    };
    __decorate([
        Property('')
    ], AIAssistView.prototype, "prompt", void 0);
    __decorate([
        Property('Type prompt for assistance...')
    ], AIAssistView.prototype, "promptPlaceholder", void 0);
    __decorate([
        Collection([], Prompt)
    ], AIAssistView.prototype, "prompts", void 0);
    __decorate([
        Property([])
    ], AIAssistView.prototype, "promptSuggestions", void 0);
    __decorate([
        Property('')
    ], AIAssistView.prototype, "promptSuggestionsHeader", void 0);
    __decorate([
        Property(true)
    ], AIAssistView.prototype, "showHeader", void 0);
    __decorate([
        Complex({ items: [] }, ToolbarSettings)
    ], AIAssistView.prototype, "toolbarSettings", void 0);
    __decorate([
        Property(0)
    ], AIAssistView.prototype, "activeView", void 0);
    __decorate([
        Property(null)
    ], AIAssistView.prototype, "promptIconCss", void 0);
    __decorate([
        Property(null)
    ], AIAssistView.prototype, "responseIconCss", void 0);
    __decorate([
        Property('100%')
    ], AIAssistView.prototype, "width", void 0);
    __decorate([
        Property('100%')
    ], AIAssistView.prototype, "height", void 0);
    __decorate([
        Property('')
    ], AIAssistView.prototype, "cssClass", void 0);
    __decorate([
        Collection([], AssistView)
    ], AIAssistView.prototype, "views", void 0);
    __decorate([
        Complex({ width: null, items: [] }, PromptToolbarSettings)
    ], AIAssistView.prototype, "promptToolbarSettings", void 0);
    __decorate([
        Complex({ width: null, items: [] }, ResponseToolbarSettings)
    ], AIAssistView.prototype, "responseToolbarSettings", void 0);
    __decorate([
        Complex({ toolbarPosition: 'Inline', items: [] }, FooterToolbarSettings)
    ], AIAssistView.prototype, "footerToolbarSettings", void 0);
    __decorate([
        Complex({ enable: false }, SpeechToTextSettings)
    ], AIAssistView.prototype, "speechToTextSettings", void 0);
    __decorate([
        Complex({}, TextToSpeechSettings)
    ], AIAssistView.prototype, "textToSpeechSettings", void 0);
    __decorate([
        Complex({ enable: false }, TelemetrySettings)
    ], AIAssistView.prototype, "telemetrySettings", void 0);
    __decorate([
        Property(false)
    ], AIAssistView.prototype, "enableAttachments", void 0);
    __decorate([
        Complex({ saveUrl: '', removeUrl: '', maxFileSize: 2000000, allowedFileTypes: '', maximumCount: 10, attachmentTemplate: '' }, AttachmentSettings)
    ], AIAssistView.prototype, "attachmentSettings", void 0);
    __decorate([
        Collection([], MentionSettings)
    ], AIAssistView.prototype, "mentions", void 0);
    __decorate([
        Property(false)
    ], AIAssistView.prototype, "showClearButton", void 0);
    __decorate([
        Property(true)
    ], AIAssistView.prototype, "enableScrollToBottom", void 0);
    __decorate([
        Property('')
    ], AIAssistView.prototype, "footerTemplate", void 0);
    __decorate([
        Property('')
    ], AIAssistView.prototype, "promptItemTemplate", void 0);
    __decorate([
        Property('')
    ], AIAssistView.prototype, "responseItemTemplate", void 0);
    __decorate([
        Property('')
    ], AIAssistView.prototype, "promptSuggestionItemTemplate", void 0);
    __decorate([
        Property('')
    ], AIAssistView.prototype, "bannerTemplate", void 0);
    __decorate([
        Property('')
    ], AIAssistView.prototype, "blockTemplate", void 0);
    __decorate([
        Property('')
    ], AIAssistView.prototype, "itemTemplate", void 0);
    __decorate([
        Property('')
    ], AIAssistView.prototype, "responseAnimationTemplate", void 0);
    __decorate([
        Event()
    ], AIAssistView.prototype, "promptRequest", void 0);
    __decorate([
        Event()
    ], AIAssistView.prototype, "promptChanged", void 0);
    __decorate([
        Event()
    ], AIAssistView.prototype, "stopRespondingClick", void 0);
    __decorate([
        Event()
    ], AIAssistView.prototype, "beforeAttachmentUpload", void 0);
    __decorate([
        Event()
    ], AIAssistView.prototype, "attachmentUploadSuccess", void 0);
    __decorate([
        Event()
    ], AIAssistView.prototype, "attachmentUploadFailure", void 0);
    __decorate([
        Event()
    ], AIAssistView.prototype, "attachmentRemoved", void 0);
    __decorate([
        Event()
    ], AIAssistView.prototype, "attachmentRemoving", void 0);
    __decorate([
        Event()
    ], AIAssistView.prototype, "editableContextClicked", void 0);
    __decorate([
        Event()
    ], AIAssistView.prototype, "mentionSelect", void 0);
    AIAssistView = __decorate([
        NotifyPropertyChanges
    ], AIAssistView);
    return AIAssistView;
}(AIAssistBase));
export { AIAssistView };
